/**
 * title 瀏覽器分頁顯示 title
 * breadcrumb 麵包屑
 * hideSideNav 是否隱藏側邊選單
 * listKeepAlive formKeepAlive subListKeepAlive 列表與表單頁間顯示的設定 (通常不用去動它)
 * submenu 是否顯示側邊子選單
 */

import Vue from "vue";
import Router from "vue-router";

// 因動態menu是透過網址的第四個區塊來判斷顯示
// 所以menu.js及router.js 中要作為顯示menu的當層 名稱需一致

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "/",
        redirect: "/login",
    },
    {
        path: "/mail",
        name: "寄信",
        component: () =>
            import("./views/Mail.vue"),
    },
    // 通用部分
    {
        path: "/login",
        name: "login",
        component: () =>
            import("./views/Login.vue"),
    },
    {
        path: "*",
        component: () =>
            import("./views/404.vue"),
    },
    {
        path: "/home",
        name: "home",
        meta: {
            title: "首頁",
            breadcrumb: "首頁",
            hideSideNav: true,
            mainHome: true,
        },
        component: () =>
            import("./views/Home.vue"),
        children: [{
            path: "person_information",
            name: "person_information",
            meta: {
                title: "個人資料管理",
                breadcrumb: "個人資料管理",
                hideSideNav: true,
            },
            component: () =>
                import("./views/PersonInformation.vue"),
        },
        {
            path: "work_manage",
            name: "work_manage",
            meta: {
                title: "工作管理",
                breadcrumb: "工作管理",
                listKeepAlive: true,
                hideSideNav: true,
            },
            component: () =>
                import("./views/WorkManage.vue"),
            children: [{
                path: ":id",
                name: "work_manage_edit",
                meta: {
                    title: "工作管理",
                    breadcrumb: "編輯",
                    hideSideNav: true,
                },
                component: () =>
                    import("./views/WorkManageEdit.vue"),
            },],
        },
        {
            path: "calendar",
            name: "work_manage_calendar",
            meta: {
                title: "工作管理",
                breadcrumb: "行事曆模式",
                hideSideNav: true,
            },
            component: () =>
                import("./views/WorkManageCalendar.vue"),
        },
        {
            path: "sysnotify",
            name: "sysnotify",
            meta: {
                title: "工作通知",
                breadcrumb: "工作通知",
                hideSideNav: true,
            },
            component: () =>
                import("./views/Sysnotify.vue"),
        },
        // 協會
        {
            path: "association",
            meta: {
                title: "協會",
            },
            component: () =>
                import("./views/association/Association.vue"),
            children: [
                // 代理人設定
                {
                    path: "agent",
                    name: "association_agent",
                    meta: {
                        title: "代理人設定",
                        breadcrumb: "代理人設定",
                        hideSideNav: true,
                        listKeepAlive: true,
                    },
                    component: () =>
                        import("./views/association/Agent.vue"),
                    children: [{
                        path: ":id",
                        name: "association_agent_edit",
                        meta: {
                            title: "代理人設定",
                            breadcrumb: "編輯",
                            hideSideNav: true,
                        },
                        component: () =>
                            import("./views/association/AgentEdit.vue"),
                    },],
                },
                // 發布工作通知
                {
                    path: "work_notice",
                    name: "work_notice",
                    meta: {
                        title: "發布工作通知",
                        breadcrumb: "發布工作通知",
                        hideSideNav: true,
                    },
                    component: () =>
                        import("./views/association/WorkNotice.vue"),
                },
                // 系統管理
                {
                    path: "association_system",
                    name: "association_system",
                    meta: {
                        title: "系統管理首頁",
                        breadcrumb: "系統管理",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/association/System/System.vue"),
                    children: [
                        // 協會使用者管理
                        {
                            path: "admin",
                            name: "admin",
                            meta: {
                                title: "協會使用者管理",
                                breadcrumb: "協會使用者管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Admin/Admin.vue"),
                            children: [{
                                path: ":id",
                                name: "admin_edit",
                                meta: {
                                    title: "基本資料",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/System/Admin/AdminEdit.vue"),
                                children: [{
                                    path: "role",
                                    name: "admin_role",
                                    meta: {
                                        title: "角色設定",
                                        breadcrumb: "角色設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Admin/AdminRole.vue"),
                                },
                                // {
                                //     path: 'permission',
                                //     name: 'admin_permission',
                                //     meta: { title: '權限設定', breadcrumb: '權限設定', submenu: true },
                                //     component: () => import('./views/association/System/Admin/AdminPermission.vue'),
                                // },
                                {
                                    path: "loginlog",
                                    name: "admin_loginlog",
                                    meta: {
                                        title: "登入紀錄",
                                        breadcrumb: "登入紀錄",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Admin/AdminLoginLog.vue"),
                                },
                                ],
                            },],
                        },
                        // 權限管理
                        {
                            path: "permission",
                            name: "permission",
                            meta: {
                                title: "權限項目管理",
                                breadcrumb: "權限項目管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/Permission.vue"),
                            children: [{
                                path: ":id",
                                name: "permission_edit",
                                meta: {
                                    title: "權限項目管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/Permission.vue"),
                            },],
                        },
                        {
                            path: "menu",
                            name: "web_menu",
                            meta: {
                                title: "選單管理",
                                breadcrumb: "選單管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/WebMenu.vue"),
                            children: [{
                                path: ":id",
                                name: "web_menu_edit",
                                meta: {
                                    title: "選單管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/WebMenu.vue"),
                            },],
                        },
                        {
                            path: "role",
                            name: "role",
                            meta: {
                                title: "角色管理",
                                breadcrumb: "角色管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/Role.vue"),
                            children: [{
                                path: ":id",
                                name: "role_edit",
                                meta: {
                                    title: "角色管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/RoleEdit.vue"),
                            },],
                        },
                        {
                            path: "associ_business",
                            name: "associ_business",
                            meta: {
                                title: "協會業務設定",
                                breadcrumb: "協會業務設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/AssociBusiness.vue"),
                            children: [{
                                path: ":id",
                                name: "associ_business_edit",
                                meta: {
                                    title: "協會業務設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/AssociBusinessEdit.vue"),
                            },],
                        },
                        {
                            path: "coop_business",
                            name: "coop_business",
                            meta: {
                                title: "儲互社設定",
                                breadcrumb: "儲互社設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/CoopBusiness.vue"),
                            children: [{
                                path: ":id",
                                name: "coop_business_edit",
                                meta: {
                                    title: "儲互社設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/CoopBusinessEdit.vue"),
                            },],
                        },
                        {
                            path: "coop_review",
                            name: "review",
                            meta: {
                                title: "儲互社審查作業",
                                breadcrumb: "儲互社審查作業",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Permission/CoopReview.vue"),
                            children: [{
                                path: ":id",
                                name: "review_edit",
                                meta: {
                                    title: "儲互社審查作業",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Permission/CoopReviewEdit.vue"),
                            },],
                        },
                        // 通用設定
                        {
                            path: "global_parameter",
                            name: "global_parameter",
                            meta: {
                                title: "全域參數設定",
                                breadcrumb: "全域參數設定",
                            },
                            component: () =>
                                import("./views/association/System/General/GlobalParameter.vue"),
                        },
                        {
                            path: "average_dividend",
                            name: "average_dividend",
                            meta: {
                                title: "歷年全國平均股息率",
                                breadcrumb: "歷年全國平均股息率",
                            },
                            component: () =>
                                import("./views/association/System/General/AverageDividend.vue"),
                        },
                        {
                            path: "project_loan",
                            name: "project_loan",
                            meta: {
                                title: "專案放款設定",
                                breadcrumb: "專案放款設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/ProjectLoan.vue"),
                            children: [{
                                path: ":id",
                                name: "project_loan_edit",
                                meta: {
                                    title: "基本資料",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/System/General/ProjectLoanEdit.vue"),
                                children: [{
                                    path: "report",
                                    name: "project_loan_report",
                                    meta: {
                                        title: "報表欄位設定",
                                        breadcrumb: "報表欄位設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/General/ProjectLoanReport.vue"),
                                },
                                {
                                    path: "application",
                                    name: "project_loan_application",
                                    meta: {
                                        title: "申請件管理",
                                        breadcrumb: "申請件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/General/ProjectLoanApplication.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "project_loan_application_list",
                                        meta: {
                                            title: "申請件列表",
                                            breadcrumb: "申請件列表",
                                            submenu: true,
                                            subFormKeepAlive: true,
                                        },
                                        component: () =>
                                            import("./views/association/System/General/ProjectLoanApplicationList.vue"),
                                        children: [{
                                            path: ":listId",
                                            name: "project_loan_application_listedit",
                                            meta: {
                                                title: "放款資料管理",
                                                submenu: true,
                                                listKeepAlive: false,
                                                subFormKeepAlive: false
                                            },
                                            component: () =>
                                                import("./views/coop/Loan/AfterLoan/AfterEdit.vue"),
                                        }]
                                    },],

                                },
                                ],
                            },],
                        },
                        {
                            path: "accounting",
                            name: "accounting",
                            meta: {
                                title: "會計科目管理",
                                breadcrumb: "會計科目管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Accounting.vue"),
                            children: [{
                                path: ":id",
                                name: "accounting_edit",
                                meta: {
                                    title: "會計科目管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/AccountingEdit.vue"),
                            },],
                        },
                        {
                            path: "gen_loan_asset_rate",
                            name: "gen_loan_asset_rate",
                            meta: {
                                title: "放款資產明細評估提撥比例設定",
                                breadcrumb: "放款資產明細評估提撥比例設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/LoanAssetRate.vue"),
                            children: [{
                                path: ":id",
                                name: "gen_loan_asset_rate_edit",
                                meta: {
                                    title: "放款資產明細評估提撥比例設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/LoanAssetRateEdit.vue"),
                            },],
                        },
                        {
                            path: "job_title",
                            name: "job_title",
                            meta: {
                                title: "職稱管理",
                                breadcrumb: "職稱管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/JobTitle.vue"),
                            children: [{
                                path: ":id",
                                name: "job_title_edit",
                                meta: {
                                    title: "職稱管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/JobTitleEdit.vue"),
                            },],
                        },

                        {
                            path: "interested_parties",
                            name: "interested_parties",
                            meta: {
                                title: "利害關係人名稱管理",
                                breadcrumb: "利害關係人名稱管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/InterestedParties.vue"),
                            children: [{
                                path: ":id",
                                name: "interested_parties_edit",
                                meta: {
                                    title: "利害關係人名稱管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/InterestedParties.vue"),
                            },],
                        },
                        {
                            path: "indigenous",
                            name: "indigenous",
                            meta: {
                                title: "族別管理",
                                breadcrumb: "族別管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Indigenous.vue"),
                            children: [{
                                path: ":id",
                                name: "indigenous_edit",
                                meta: {
                                    title: "族別管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/Indigenous.vue"),
                            },],
                        },
                        {
                            path: "job",
                            name: "job",
                            meta: {
                                title: "職業管理",
                                breadcrumb: "職業管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Job.vue"),
                            children: [{
                                path: ":id",
                                name: "job_edit",
                                meta: {
                                    title: "職業管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/Job.vue"),
                            },],
                        },
                        {
                            path: "prompt",
                            name: "prompt",
                            meta: {
                                title: "法催工作設定",
                                breadcrumb: "法催工作設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Prompt.vue"),
                            children: [{
                                path: ":id",
                                name: "prompt_edit",
                                meta: {
                                    title: "法催工作設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/Prompt.vue"),
                            },],
                        },
                        {
                            path: "loan_purpose",
                            name: "loan_purpose",
                            meta: {
                                title: "借款用途",
                                breadcrumb: "借款用途",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/LoanPurpose.vue"),
                            children: [{
                                path: ":id",
                                name: "loan_purpose_edit",
                                meta: {
                                    title: "借款用途",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/LoanPurposeEdit.vue"),
                            },],
                        },
                        {
                            path: "loan_break_exception",
                            name: "loan_break_exception",
                            meta: {
                                title: "還款寬限例外設定",
                                breadcrumb: "還款寬限例外設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/LoanBreakException.vue"),
                            children: [{
                                path: ":id",
                                name: "loan_break_exception_edit",
                                meta: {
                                    title: "還款寬限例外設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/LoanBreakExceptionEdit.vue"),
                            },],
                        },
                        {
                            path: "area",
                            name: "area",
                            meta: {
                                title: "區會管理",
                                breadcrumb: "區會管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Area.vue"),
                            children: [{
                                path: ":id",
                                name: "area_edit",
                                meta: {
                                    title: "區會管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/AreaEdit.vue"),
                            },],
                        },
                        {
                            path: "country",
                            name: "country",
                            meta: {
                                title: "縣市區域管理",
                                breadcrumb: "縣市區域管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/Country.vue"),
                            children: [{
                                path: ":id",
                                name: "country_edit",
                                meta: {
                                    title: "縣市區域管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/Country.vue"),
                            },],
                        },
                        {
                            path: "system_scheduling",
                            name: "system_scheduling",
                            meta: {
                                title: "系統排程",
                                breadcrumb: "系統排程",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/General/SystemScheduling.vue"),
                            children: [{
                                path: ":id",
                                name: "system_scheduling_edit",
                                meta: {
                                    title: "系統排程",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/General/SystemSchedulingEdit.vue"),
                            },],
                        },
                        {
                            path: "exit_reason",
                            name: "exit_reason",
                            meta: {
                                title: "退社原因設定",
                                breadcrumb: "退社原因設定",
                            },
                            component: () =>
                                import("./views/association/System/General/ExitReason.vue"),
                        },
                        // 儲互社管理
                        {
                            path: "coop",
                            name: "associattion_coop",
                            meta: {
                                title: "儲互社管理",
                                breadcrumb: "儲互社管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Coop/Coop.vue"),
                            children: [{
                                path: ":id",
                                name: "associattion_coop_edit",
                                meta: {
                                    title: "儲互社基本資料",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/System/Coop/CoopEdit.vue"),
                                children: [{
                                    path: "member",
                                    name: "associattion_coop_member",
                                    meta: {
                                        title: "儲互社人員管理",
                                        breadcrumb: "儲互社人員管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Coop/CoopMember.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "associattion_coop_member_edit",
                                        meta: {
                                            title: "基本資料",
                                            submenu: true,
                                            subFormKeepAlive: true,
                                        },
                                        component: () =>
                                            import("./views/association/System/Coop/CoopMemberEdit.vue"),
                                        children: [{
                                            path: "role",
                                            name: "associattion_coop_member_role",
                                            meta: {
                                                title: "角色設定",
                                                breadcrumb: "角色設定",
                                                submenu: true,
                                            },
                                            component: () =>
                                                import("./views/association/System/Coop/CoopMemberRole.vue"),
                                        },
                                        // {
                                        //     path: 'permission',
                                        //     name: 'associattion_coop_member_permission',
                                        //     meta: { title: '權限設定', breadcrumb: '權限設定', submenu: true },
                                        //     component: () => import('./views/association/System/Coop/CoopMemberPermission.vue'),
                                        // },
                                        {
                                            path: "loginlog",
                                            name: "associattion_coop_member_loginlog",
                                            meta: {
                                                title: "登入紀錄",
                                                breadcrumb: "登入紀錄",
                                                submenu: true,
                                            },
                                            component: () =>
                                                import("./views/association/System/Coop/CoopMemberLoginLog.vue"),
                                        },
                                        ],
                                    },],
                                },
                                {
                                    path: "time",
                                    name: "associattion_coop_time",
                                    meta: {
                                        title: "儲互社營業時間",
                                        breadcrumb: "儲互社營業時間",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Coop/CoopTime.vue"),
                                },
                                {
                                    path: "device",
                                    name: "associattion_coop_device",
                                    meta: {
                                        title: "儲互社裝置管理",
                                        breadcrumb: "儲互社裝置管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Coop/CoopDevice.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "associattion_coop_device_edit",
                                        meta: {
                                            title: "儲互社裝置管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/System/Coop/CoopDeviceEdit.vue"),
                                    },],
                                },
                                {
                                    path: "review",
                                    name: "associattion_coop_review",
                                    meta: {
                                        title: "儲互社審查作業設定",
                                        breadcrumb: "儲互社審查作業設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Coop/CoopReview.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "associattion_coop_review_edit",
                                        meta: {
                                            title: "儲互社審查作業設定",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/System/Coop/CoopReviewEdit.vue"),
                                    },],
                                },
                                {
                                    path: "lending",
                                    name: "associattion_coop_lending",
                                    meta: {
                                        title: "放款開放設定",
                                        breadcrumb: "放款開放設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/System/Coop/CoopLending.vue"),
                                },
                                ],
                            },],
                        },
                        // 系統訊息管理
                        {
                            path: "message",
                            name: "message",
                            meta: {
                                title: "訊息設定",
                                breadcrumb: "訊息設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SystemMessage/Message.vue"),
                            children: [{
                                path: ":id",
                                name: "message_edit",
                                meta: {
                                    title: "訊息設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SystemMessage/MessageEdit.vue"),
                            },],
                        },
                        {
                            path: "error_message",
                            name: "error_message",
                            meta: {
                                title: "錯誤訊息管理",
                                breadcrumb: "錯誤訊息管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SystemMessage/ErrorMessage.vue"),
                            children: [{
                                path: ":id",
                                name: "error_message_edit",
                                meta: {
                                    title: "錯誤訊息管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SystemMessage/ErrorMessageEdit.vue"),
                            },],
                        },
                        // 公告管理
                        {
                            path: "announcement",
                            name: "announcement",
                            meta: {
                                title: "公告管理",
                                breadcrumb: "公告管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Announcement/Announcement.vue"),
                            children: [{
                                path: ":id",
                                name: "announcement_edit",
                                meta: {
                                    title: "公告管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/Announcement/AnnouncementEdit.vue"),
                            },],
                        },
                        // 簡訊管理
                        {
                            path: "sms_use",
                            name: "association_sms_use",
                            meta: {
                                title: "簡訊使用記錄管理",
                                breadcrumb: "簡訊使用記錄管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SMS/SmsUse.vue"),
                            children: [{
                                path: ":id",
                                name: "association_sms_use_edit",
                                meta: {
                                    title: "簡訊使用記錄管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SMS/SmsUseEdit.vue"),
                            },],
                        },
                        {
                            path: "sms_buy",
                            name: "association_sms_buy",
                            meta: {
                                title: "簡訊購買記錄管理",
                                breadcrumb: "簡訊購買記錄管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SMS/SmsBuy.vue"),
                            children: [{
                                path: ":id",
                                name: "association_sms_buy_edit",
                                meta: {
                                    title: "簡訊購買記錄管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SMS/SmsBuyEdit.vue"),
                            },],
                        },
                        {
                            path: "coop_sms_buy",
                            name: "coop_sms_buy",
                            meta: {
                                title: "儲互社簡訊購買記錄管理",
                                breadcrumb: "儲互社簡訊購買記錄管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SMS/CoopSmsBuy.vue"),
                            children: [{
                                path: ":id",
                                name: "coop_sms_buy_edit",
                                meta: {
                                    title: "儲互社簡訊購買記錄管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SMS/CoopSmsBuyEdit.vue"),
                            },],
                        },
                        {
                            path: "coop_sms_use",
                            name: "coop_sms_use",
                            meta: {
                                title: "儲互社簡訊使用記錄管理",
                                breadcrumb: "儲互社簡訊使用記錄管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/SMS/CoopSmsUse.vue"),
                            children: [{
                                path: ":id",
                                name: "coop_sms_use_edit",
                                meta: {
                                    title: "儲互社簡訊使用記錄管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/System/SMS/CoopSmsUseEdit.vue"),
                            },],
                        },
                        {
                            path: "sms_setting",
                            name: "sms_setting",
                            meta: {
                                title: "簡訊相關設定",
                                breadcrumb: "簡訊相關設定",
                            },
                            component: () =>
                                import("./views/association/System/SMS/SmsSetting.vue"),
                        },
                    ],
                },
                // 安基業務管理
                {
                    path: "anji_business",
                    name: "anji_business",
                    meta: {
                        title: "安基業務首頁",
                        breadcrumb: "安基業務",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/association/AnjiBusiness/AnjiBusiness.vue"),
                    children: [
                        // 收件作業
                        {
                            path: "receiving_work",
                            name: "receiving_work",
                            meta: {
                                title: "收件作業",
                                breadcrumb: "收件作業",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/AnjiBusiness/ReceivingWork.vue"),
                            children: [{
                                path: "receive",
                                name: "receiving_work_edit",
                                meta: {
                                    title: "收件作業",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/AnjiBusiness/ReceivingWorkEdit.vue"),
                            },],
                        },
                        // 儲互社安基資料管理
                        {
                            path: "coop_anji",
                            name: "coop_anji",
                            meta: {
                                title: "儲互社安基資料管理",
                                breadcrumb: "儲互社安基資料管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/AnjiBusiness/CoopAnji.vue"),
                            children: [{
                                path: ":id",
                                name: "coop_anji_edit",
                                redirect: (to) => {
                                    return {
                                        name: "coop_anji_participation",
                                        params: { id: to.params.id }
                                    };
                                },
                                meta: {
                                    title: "基本資料",
                                    submenu: false,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/System/Coop/CoopEdit.vue"),
                                children: [{
                                    path: "participation",
                                    name: "coop_anji_participation",
                                    meta: {
                                        title: "開辦狀況",
                                        breadcrumb: "開辦狀況",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AnjiBusiness/CoopAnjiParticipation.vue"),
                                },
                                {
                                    path: "member_participation",
                                    name: "coop_anji_memberparticipation",
                                    meta: {
                                        title: "社員參與狀況",
                                        breadcrumb: "社員參與狀況",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AnjiBusiness/CoopAnjiMemberParticipation.vue"),
                                },
                                {
                                    path: "member_claim",
                                    name: "coop_anji_memberclaim",
                                    meta: {
                                        title: "社員理賠管理",
                                        breadcrumb: "社員理賠管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AnjiBusiness/CoopAnjiMemberClaim.vue"),
                                },
                                ],
                            },],
                        },
                        // 六年平儲
                        {
                            path: "six_year",
                            name: "association_six_year",
                            meta: {
                                title: "六年平儲專案設定",
                                breadcrumb: "六年平儲專案設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/SixYear/SixYear.vue"),
                            children: [{
                                path: ":id",
                                name: "association_six_year_edit",
                                meta: {
                                    title: "基本資料",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/SixYear/SixYearEdit.vue"),
                                children: [{
                                    path: "start",
                                    name: "association_six_year_start",
                                    meta: {
                                        title: "開辦設定",
                                        breadcrumb: "開辦設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/SixYear/SixYearStart.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "association_six_year_start_edit",
                                        meta: {
                                            title: "開辦設定",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/SixYear/SixYearStartEdit.vue"),
                                    },],
                                },
                                {
                                    path: "parameter",
                                    name: "association_six_year_parameter",
                                    meta: {
                                        title: "參數設定",
                                        breadcrumb: "參數設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/SixYear/SixYearParameter.vue"),
                                },
                                ],
                            },],
                        },
                        // LPLS
                        {
                            path: "lpls",
                            name: "lpls",
                            meta: {
                                title: "LPLS",
                                breadcrumb: "LPLS",
                            },
                            component: () =>
                                import("./views/association/LPLS/LPLS.vue"),
                            children: [{
                                path: "parameter",
                                name: "lpls_parameter",
                                meta: {
                                    title: "參數設定",
                                    breadcrumb: "參數設定",
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSParameter.vue"),
                                children: [{
                                    path: ":id",
                                    name: "lpls_parameter_edit",
                                    meta: {
                                        title: "參數設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSParameterEdit.vue"),
                                    children: [{
                                        path: "history",
                                        name: "lpls_parameter_history",
                                        meta: {
                                            title: "歷史紀錄",
                                            breadcrumb: "歷史紀錄",
                                        },
                                        component: () =>
                                            import("./views/association/LPLS/LPLSParameterHistory.vue"),
                                    },],
                                },],
                            },
                            {
                                path: "annual_guarantee",
                                name: "lpls_annual_guarantee",
                                meta: {
                                    title: "年度與保障期間設定",
                                    breadcrumb: "年度與保障期間設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSAnnualGuarantee.vue"),
                                children: [{
                                    path: ":id",
                                    name: "lpls_annual_guarantee_edit",
                                    meta: {
                                        title: "年度與保障期間設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSAnnualGuaranteeEdit.vue"),
                                },],
                            },
                            {
                                path: "lp_coop_rate",
                                name: "lp_coop_rate",
                                meta: {
                                    title: "LP儲互社費率及保額設定",
                                    breadcrumb: "LP儲互社費率及保額設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSCoopRate.vue"),
                                children: [{
                                    path: ":code",
                                    name: "lp_coop_rate_edit",
                                    meta: {
                                        title: "費率及保額設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSCoopRateEdit.vue"),
                                },],
                            },
                            {
                                path: "ls_coop_rate",
                                name: "ls_coop_rate",
                                meta: {
                                    title: "LS儲互社費率及保額設定",
                                    breadcrumb: "LS儲互社費率及保額設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSCoopRate.vue"),
                                children: [{
                                    path: ":code",
                                    name: "ls_coop_rate_edit",
                                    meta: {
                                        title: "費率及保額設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSCoopRateEdit.vue"),
                                },],
                            },
                            {
                                path: "claim_application",
                                name: "lpls_claim_application",
                                meta: {
                                    title: "LPLS理賠申請",
                                    breadcrumb: "LPLS理賠申請",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSClaimApplication.vue"),
                                children: [{
                                    path: ":id",
                                    name: "lpls_claim_application_edit",
                                    meta: {
                                        title: "LPLS理賠申請",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSClaimApplicationEdit.vue"),
                                },],
                            },
                            {
                                path: "announcement",
                                name: "lpls_announcement",
                                meta: {
                                    title: "LPLS 申報表公告設定",
                                    breadcrumb: "LPLS 申報表公告設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/LPLS/LPLSAnnouncement.vue"),
                                children: [{
                                    path: ":id",
                                    name: "lpls_announcement_edit",
                                    meta: {
                                        title: "LPLS 申報表公告設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/LPLS/LPLSAnnouncement.vue"),
                                },],
                            },
                            ],
                        },
                        // BOND
                        {
                            path: "bond",
                            name: "bond",
                            meta: {
                                title: "BOND",
                                breadcrumb: "BOND",
                            },
                            component: () =>
                                import("./views/association/BOND/BOND.vue"),
                            children: [{
                                path: "parameter",
                                name: "bond_parameter",
                                meta: {
                                    title: "參數設定",
                                    breadcrumb: "參數設定",
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDParameter.vue"),
                            },
                            {
                                path: "edit",
                                name: "bond_parameter_edit",
                                meta: {
                                    title: "參數設定",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDParameterEdit.vue"),
                            },
                            {
                                path: "annual_guarantee",
                                name: "bond_annual_guarantee",
                                meta: {
                                    title: "年度與保障期間設定",
                                    breadcrumb: "年度與保障期間設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDAnnualGuarantee.vue"),
                                children: [{
                                    path: ":id",
                                    name: "bond_annual_guarantee_edit",
                                    meta: {
                                        title: "年度與保障期間設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/BOND/BONDAnnualGuaranteeEdit.vue"),
                                },],
                            },
                            {
                                path: "discount",
                                name: "bond_discount",
                                meta: {
                                    title: "折扣率設定",
                                    breadcrumb: "折扣率設定",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDDiscount.vue"),
                                children: [{
                                    path: ":id",
                                    name: "bond_discount_edit",
                                    meta: {
                                        title: "折扣率設定",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/BOND/BONDDiscountEdit.vue"),
                                },],
                            },
                            {
                                path: "annual_renewal",
                                name: "bond_annual_renewal",
                                meta: {
                                    title: "年度續約申請管理",
                                    breadcrumb: "年度續約申請管理",
                                    listKeepAlive: true,
                                    newbutton: true,
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDAnnualRenewal.vue"),
                                children: [{
                                    path: ":id",
                                    name: "bond_annual_renewal_edit",
                                    meta: {
                                        title: "年度續約申請管理",
                                        breadcrumb: "編輯",
                                        formKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/BOND/BONDAnnualRenewalEdit.vue"),
                                    children: [{
                                        path: "content",
                                        name: "bond_annual_renewal_content",
                                        meta: {
                                            title: "年度續約申請管理",
                                            breadcrumb: "申請內容",
                                        },
                                        component: () =>
                                            import("./views/association/BOND/BONDAnnualRenewalContent.vue"),
                                    },],
                                },],
                            },
                            {
                                path: "bond_claim_application",
                                name: "bond_bond_claim_application",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "理賠申請管理",
                                    listKeepAlive: true,
                                    statusButton: true,
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDClaimApplication.vue"),
                                children: [{
                                    path: ":id",
                                    name: "bond_bond_claim_application_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/association/BOND/BONDClaimApplicationEdit.vue"),
                                },],
                            },
                            {
                                path: "report",
                                name: "bond_report",
                                meta: {
                                    title: "相關報表",
                                    breadcrumb: "相關報表",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/BOND/BONDReport.vue"),
                                children: [{
                                    path: ":id/view",
                                    name: "bond_bond_claim_ApplyRecord",
                                    meta: {
                                        title: "年度續約申請",
                                        breadcrumb: "申請紀錄",
                                    },
                                    component: () =>
                                        import("./views/association/BOND/BONDReportReview.vue"),
                                },],
                            },
                            ],
                        },
                        // 代辦互助基金
                        {
                            path: "agency",
                            name: "agency",
                            meta: {
                                title: "代辦互助基金",
                                breadcrumb: "代辦互助基金",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/AgencyFund/Agency.vue"),
                            children: [{
                                path: ":code",
                                name: "agency_edit",
                                meta: {
                                    title: "基本資料",
                                    submenu: true,
                                    formKeepAlive: true,
                                    changeBreadcrumb: true
                                },
                                component: () =>
                                    import("./views/association/AgencyFund/AgencyEdit.vue"),
                                children: [{
                                    path: "annual_guarantee",
                                    name: "agency_annualguarantee",
                                    meta: {
                                        title: "年度與保障期間設定",
                                        breadcrumb: "年度與保障期間設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyAnnualGuarantee.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_annualguarantee_edit",
                                        meta: {
                                            title: "年度與保障期間設定",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyAnnualGuaranteeEdit.vue"),
                                    },],
                                },
                                {
                                    path: "subprogram",
                                    name: "agency_subprogram",
                                    meta: {
                                        title: "子方案設定",
                                        breadcrumb: "子方案設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencySubprogram.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_subprogram_edit",
                                        meta: {
                                            title: "子方案設定",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencySubprogramEdit.vue"),
                                    },],
                                },
                                {
                                    path: "handlingFee",
                                    name: "agency_handlingFee",
                                    meta: {
                                        title: "經辦費設定",
                                        breadcrumb: "經辦費設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyHandlingFee.vue"),
                                },
                                {
                                    path: "plus_surrender",
                                    name: "agency_plussurrender",
                                    meta: {
                                        title: "加退保名冊設定",
                                        breadcrumb: "加退保名冊設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencySurrenderInout.vue"),
                                },
                                {
                                    path: "change_surrender",
                                    name: "agency_changesurrender",
                                    meta: {
                                        title: "資料變更名冊設定",
                                        breadcrumb: "資料變更名冊設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencySurrenderChange.vue"),
                                },
                                {
                                    path: "doc",
                                    name: "agency_doc",
                                    meta: {
                                        title: "相關文件設定",
                                        breadcrumb: "相關文件設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyDoc.vue"),
                                },
                                {
                                    path: "accounting",
                                    name: "agency_accounting",
                                    meta: {
                                        title: "會計科目設定",
                                        breadcrumb: "會計科目設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyAccounting.vue"),
                                },
                                {
                                    path: "claims_doc",
                                    name: "agency_claimsdoc",
                                    meta: {
                                        title: "理賠項目與文件設定",
                                        breadcrumb: "理賠項目與文件設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyClaimsDoc.vue"),
                                },
                                {
                                    path: "coop_start",
                                    name: "agency_coopstart",
                                    meta: {
                                        title: "儲互社開辦管理",
                                        breadcrumb: "儲互社開辦管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyCoopStart.vue"),
                                    children: [{
                                        path: ":coopCode",
                                        name: "agency_coopstart_edit",
                                        meta: {
                                            title: "儲互社開辦管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyCoopStartEdit.vue"),
                                    },],
                                },
                                {
                                    path: "report",
                                    name: "agency_report",
                                    meta: {
                                        title: "相關報表",
                                        breadcrumb: "相關報表",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyReport.vue"),
                                },
                                {
                                    path: "executive_roster",
                                    name: "agency_executiveroster",
                                    meta: {
                                        title: "儲互社參加名冊管理",
                                        breadcrumb: "儲互社參加名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgentExecutiveRoster.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_executiveroster_edit",
                                        meta: {
                                            title: "儲互社參加名冊管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgentExecutiveRosterEdit.vue"),
                                    },],
                                },
                                {
                                    path: "coop_plus_delivery",
                                    name: "agency_coopplusdelivery",
                                    meta: {
                                        title: "儲互社加退保申請送件管理",
                                        breadcrumb: "儲互社加退保申請送件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyCoopPlusDelivery.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_coopplusdelivery_edit",
                                        meta: {
                                            title: "儲互社加退保申請送件管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyCoopPlusDeliveryEdit.vue"),
                                    },],
                                },
                                {
                                    path: "coop_plus_roster",
                                    name: "agency_coopplusroster",
                                    meta: {
                                        title: "儲互社加保申請名冊管理",
                                        breadcrumb: "儲互社加保申請名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyCoopPlusRoster.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_coopplusroster_edit",
                                        meta: {
                                            title: "編輯",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyCoopPlusRosterEdit.vue"),
                                    },],
                                },
                                {
                                    path: "coop_change_delivery",
                                    name: "agency_coopchangedelivery",
                                    meta: {
                                        title: "儲互社資料變更申請送件管理",
                                        breadcrumb: "儲互社資料變更申請送件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyCoopChangeDelivery.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_coopchangedelivery_edit",
                                        meta: {
                                            title: "儲互社資料變更申請送件管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyCoopChangeDeliveryEdit.vue"),
                                    },],
                                },
                                {
                                    path: "coop_claim_application",
                                    name: "agency_coopclaimapplication",
                                    meta: {
                                        title: "儲互社理賠申請管理",
                                        breadcrumb: "儲互社理賠申請管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/AgencyFund/AgencyCoopClaimApplication.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agency_coopclaimapplication_edit",
                                        meta: {
                                            title: "儲互社理賠申請管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/AgencyFund/AgencyCoopClaimApplicationEdit.vue"),
                                    },],
                                },
                                ],
                            },],
                        },
                        // 幹部互助基金
                        {
                            path: "cadre",
                            name: "cadre",
                            meta: {
                                title: "各級幹部互助基金",
                                breadcrumb: "各級幹部互助基金",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/CadreFund/Cadre.vue"),
                            children: [{
                                path: "annual_guarantee",
                                name: "cadre_annualguarantee",
                                meta: {
                                    title: "年度與保障期間設定",
                                    breadcrumb: "年度與保障期間設定",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreAnnualGuarantee.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadre_annualguarantee_edit",
                                    meta: {
                                        title: "年度與保障期間設定",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreAnnualGuaranteeEdit.vue"),
                                },],
                            },
                            {
                                path: "subprogram",
                                name: "cadre_subprogram",
                                meta: {
                                    title: "子方案設定",
                                    breadcrumb: "子方案設定",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreSubprogram.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadre_subprogram_edit",
                                    meta: {
                                        title: "子方案設定",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreSubprogramEdit.vue"),
                                },],
                            },
                            {
                                path: "handlingFee",
                                name: "cadre_handlingFee",
                                meta: {
                                    title: "經辦費設定",
                                    breadcrumb: "經辦費設定",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreHandlingFee.vue"),
                            },
                            {
                                path: "accounting",
                                name: "cadre_accounting",
                                meta: {
                                    title: "會計科目設定",
                                    breadcrumb: "會計科目設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreAccounting.vue"),
                            },
                            {
                                path: "doc",
                                name: "cadre_doc",
                                meta: {
                                    title: "相關文件設定",
                                    breadcrumb: "相關文件設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreDoc.vue"),
                            },
                            {
                                path: "plus_surrender",
                                name: "cadre_plussurrender",
                                meta: {
                                    title: "加退保名冊設定",
                                    breadcrumb: "加退保名冊設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreSurrenderInout.vue"),
                            },
                            {
                                path: "change_surrender",
                                name: "cadre_changesurrender",
                                meta: {
                                    title: "資料變更名冊設定",
                                    breadcrumb: "資料變更名冊設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreSurrenderChange.vue"),
                            },
                            {
                                path: "claim_doc",
                                name: "cadre_claimdoc",
                                meta: {
                                    title: "理賠項目與文件設定",
                                    breadcrumb: "理賠項目與文件設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreClaimDoc.vue"),
                            },
                            // {
                            //     path: 'plus_roster',
                            //     name: 'cadre_coopplusroster',
                            //     meta: { title: '退保申請名冊', breadcrumb: '加退保申請名冊', subListKeepAlive: true, submenu: true },
                            //     component: () => import('./views/association/CadreFund/CadreCoopPlusRoster.vue'),
                            // },
                            {
                                path: "plus_apply_roster",
                                name: "cadre_plusapplyroster",
                                meta: {
                                    title: "加退保申請名冊",
                                    breadcrumb: "加退保申請名冊",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadrePlusApplyRoster.vue"),
                            },
                            {
                                path: "executive_roster",
                                name: "cadre_executiveroster",
                                meta: {
                                    title: "參加名冊管理",
                                    breadcrumb: "參加名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreExecutiveRoster.vue"),
                                children: [{
                                    path: ":id",
                                    name: "cadre_executiveroster_edit",
                                    meta: {
                                        title: "儲互社參加名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreExecutiveRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_plus_delivery",
                                name: "cadre_coopplusdelivery",
                                meta: {
                                    title: "儲互社加退保申請送件管理",
                                    breadcrumb: "儲互社加退保申請送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreCoopPlusDelivery.vue"),
                                children: [{
                                    path: ":id",
                                    name: "cadre_coopplusdelivery_edit",
                                    meta: {
                                        title: "儲互社加退保申請送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreCoopPlusDeliveryEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_plus_roster",
                                name: "cadre_coopplusroster",
                                meta: {
                                    title: "儲互社加保申請名冊管理",
                                    breadcrumb: "儲互社加保申請名冊管理",
                                    subListKeepAlive: true,
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreCoopPlusRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadre_coopplusroster_edit",
                                    meta: {
                                        title: "儲互社加保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreCoopPlusRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "change_roster_manage",
                                name: "cadre_changerostermanage",
                                meta: {
                                    title: "資料變更名冊管理",
                                    breadcrumb: "資料變更名冊管理",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreChangeRosterManage.vue"),
                            },
                            {
                                path: "coop_change_delivery",
                                name: "cadre_coopchangedelivery",
                                meta: {
                                    title: "儲互社資料變更申請送件管理",
                                    breadcrumb: "儲互社資料變更申請送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreCoopChangeDelivery.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadre_coopchangedelivery_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreCoopChangeDeliveryEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_claim_application",
                                name: "cadre_claimapplication",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "儲互社理賠申請管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/CadreFund/CadreCoopClaimApplication.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadre_claimapplication_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/CadreFund/CadreCoopClaimApplicationEdit.vue"),
                                },],
                            },
                            ],
                        },
                        //協會員工福利團體保險
                        {
                            path: "employee",
                            name: "employee",
                            meta: {
                                title: "員工福利團體保險",
                                breadcrumb: "員工福利團體保險",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/Employee/Employee.vue"),
                            children: [{
                                path: "annual_guarantee",
                                name: "employee_annualguarantee",
                                meta: {
                                    title: "年度與保障期間設定",
                                    breadcrumb: "年度與保障期間設定",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeAnnualGuarantee.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employee_annualguarantee_edit",
                                    meta: {
                                        title: "年度與保障期間設定",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeAnnualGuaranteeEdit.vue"),
                                },],
                            },
                            {
                                path: "subprogram",
                                name: "employee_subprogram",
                                meta: {
                                    title: "子方案設定",
                                    breadcrumb: "子方案設定",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeSubprogram.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employee_subprogram_edit",
                                    meta: {
                                        title: "子方案設定",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeSubprogramEdit.vue"),
                                },],
                            },
                            {
                                path: "accounting",
                                name: "employee_accounting",
                                meta: {
                                    title: "會計科目設定",
                                    breadcrumb: "會計科目設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeAccounting.vue"),
                            },
                            {
                                path: "doc",
                                name: "employee_doc",
                                meta: {
                                    title: "相關文件設定",
                                    breadcrumb: "相關文件設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeDoc.vue"),
                            },
                            {
                                path: "plus_surrender",
                                name: "employee_plussurrender",
                                meta: {
                                    title: "加退保名冊設定",
                                    breadcrumb: "加退保名冊設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeSurrenderInout.vue"),
                            },
                            {
                                path: "change_surrender",
                                name: "employee_changesurrender",
                                meta: {
                                    title: "資料變更名冊設定",
                                    breadcrumb: "資料變更名冊設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeSurrenderChange.vue"),
                            },
                            {
                                path: "claim_doc",
                                name: "employee_claimdoc",
                                meta: {
                                    title: "理賠項目與文件設定",
                                    breadcrumb: "理賠項目與文件設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeClaimDoc.vue"),
                            },
                            {
                                path: "plus_apply_roster",
                                name: "employee_plusapplyroster",
                                meta: {
                                    title: "加退保申請名冊",
                                    breadcrumb: "加退保申請名冊",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeePlusApplyRoster.vue"),
                            },
                            {
                                path: "executive_roster",
                                name: "employee_executiveroster",
                                meta: {
                                    title: "參加名冊管理",
                                    breadcrumb: "參加名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeExecutiveRoster.vue"),
                                children: [{
                                    path: ":id",
                                    name: "employee_executiveroster_edit",
                                    meta: {
                                        title: "儲互社參加名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeExecutiveRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_plus_delivery",
                                name: "employee_coopplusdelivery",
                                meta: {
                                    title: "儲互社加退保申請送件管理",
                                    breadcrumb: "儲互社加退保申請送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeCoopPlusDelivery.vue"),
                                children: [{
                                    path: ":id",
                                    name: "employee_coopplusdelivery_edit",
                                    meta: {
                                        title: "儲互社加退保申請送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeCoopPlusDeliveryEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_plus_roster",
                                name: "employee_coopplusroster",
                                meta: {
                                    title: "儲互社加保申請名冊管理",
                                    breadcrumb: "儲互社加保申請名冊管理",
                                    subListKeepAlive: true,
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeCoopPlusRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employee_coopplusroster_edit",
                                    meta: {
                                        title: "儲互社加保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeCoopPlusRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "change_roster_manage",
                                name: "employee_changerostermanage",
                                meta: {
                                    title: "資料變更名冊管理",
                                    breadcrumb: "資料變更名冊管理",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeChangeRosterManage.vue"),
                            },
                            {
                                path: "coop_change_delivery",
                                name: "employee_coopchangedelivery",
                                meta: {
                                    title: "儲互社資料變更申請送件管理",
                                    breadcrumb: "儲互社資料變更申請送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeCoopChangeDelivery.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employee_coopchangedelivery_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeCoopChangeDeliveryEdit.vue"),
                                },],
                            },
                            {
                                path: "coop_claim_application",
                                name: "employee_claimapplication",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "儲互社理賠申請管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Employee/EmployeeCoopClaimApplication.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employee_claimapplication_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Employee/EmployeeCoopClaimApplicationEdit.vue"),
                                },],
                            },
                            ],
                        },
                    ],
                },
                // 督導資料查詢
                {
                    path: "supervision",
                    name: "supervision",
                    meta: {
                        title: "督導業務查詢首頁",
                        breadcrumb: "督導業務查詢",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/association/Supervision/Supervision.vue"),
                    children: [{
                        path: "coop",
                        name: "super_coop",
                        meta: {
                            title: "儲互社管理",
                            breadcrumb: "儲互社管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/Supervision/SupervisionCoop.vue"),
                        children: [{
                            path: ":id",
                            name: "super_coop_edit",
                            meta: {
                                title: "儲互社基本資料",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/Supervision/SupervisionCoopEdit.vue"),
                            children: [{
                                path: "member",
                                name: "super_coop_member",
                                meta: {
                                    title: "儲互社人員管理",
                                    breadcrumb: "儲互社人員管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopMember.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "super_coop_member_edit",
                                    meta: {
                                        title: "基本資料",
                                        submenu: true,
                                        subFormKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/Supervision/SupervisionCoopMemberEdit.vue"),
                                    children: [{
                                        path: "role",
                                        name: "super_coop_member_role",
                                        meta: {
                                            title: "角色設定",
                                            breadcrumb: "角色設定",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/Supervision/SupervisionMemberRole.vue"),
                                    },
                                    // {
                                    //     path: 'permission',
                                    //     name: 'super_coop_member_permission',
                                    //     meta: { title: '權限設定', breadcrumb: '權限設定', submenu: true },
                                    //     component: () => import('./views/association/System/Coop/CoopMemberPermission.vue'),
                                    // },
                                    {
                                        path: "loginlog",
                                        name: "super_coop_member_loginlog",
                                        meta: {
                                            title: "登入紀錄",
                                            breadcrumb: "登入紀錄",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/association/Supervision/SupversionMemberLoginLog.vue"),
                                    },
                                    ],
                                },],
                            },
                            {
                                path: "time",
                                name: "super_coop_time",
                                meta: {
                                    title: "儲互社營業時間",
                                    breadcrumb: "儲互社營業時間",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopTime.vue"),
                            },
                            {
                                path: "device",
                                name: "super_coop_device",
                                meta: {
                                    title: "儲互社裝置管理",
                                    breadcrumb: "儲互社裝置管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopDevice.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "super_coop_device_edit",
                                    meta: {
                                        title: "儲互社裝置管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/association/Supervision/SupervisionCoopDeviceEdit.vue"),
                                },],
                            },
                            {
                                path: "search",
                                name: "super_coop_search",
                                meta: {
                                    title: "儲互社資料查詢",
                                    breadcrumb: "儲互社資料查詢",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopSearch.vue"),
                            },
                            {
                                path: "attendance",
                                name: "super_coop_attendance",
                                meta: {
                                    title: "儲互社出勤狀態查詢",
                                    breadcrumb: "儲互社出勤狀態查詢",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopAttendance.vue"),
                            },
                            {
                                path: "leave",
                                name: "super_coop_leave",
                                meta: {
                                    title: "人員請假紀錄",
                                    breadcrumb: "人員請假紀錄",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopLeave.vue"),
                            },
                            {
                                path: "checkwork",
                                name: "super_coop_checkwork",
                                meta: {
                                    title: "查核工作底稿",
                                    breadcrumb: "查核工作底稿",
                                    submenu: true,
                                    subFormKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionCoopCheckwork.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "super_coop_checkwork_edit",
                                    meta: {
                                        title: "查核工作底稿編輯",
                                        breadcrumb: "查核工作底稿編輯",
                                        submenu: true,
                                        subIouFormKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/association/Supervision/SupervisionCoopCheckworkEdit.vue"),
                                    children: [{
                                        path: "ioureviewid/:iouSubId",
                                        name: "super_coop_checkwork_iou_edit",
                                        meta: {
                                            title: "查核工作底稿借據編輯",
                                            breadcrumb: "查核工作底稿借據編輯",
                                        },
                                        component: () =>
                                            import("./views/association/Supervision/SupervisionCoopCheckworkIouEdit.vue"),
                                    },],
                                },],
                            },
                            ],
                        },],
                    },
                    {
                        path: "iou_modify_review",
                        name: "supervision_business_iou_modify_review",
                        meta: {
                            title: "借款條件異動處理審核",
                            breadcrumb: "借款條件異動處理審核",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/Supervision/SupervisionBusinessIouModifyReview.vue"),
                        children: [{
                            path: ":id/review/:subId",
                            name: "supervision_review_iou_modify_edit",
                            meta: {
                                title: "借款條件異動處理審核",
                                breadcrumb: "審核",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/Supervision/SupervisionBusinessIouModifyReviewEdit.vue"),
                        },],
                    },
                    {
                        path: "business_review",
                        name: "supervision_business_review",
                        meta: {
                            title: "業務審核",
                            breadcrumb: "業務審核",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/Supervision/SupervisionBusinessReview.vue"),
                        children: [{
                            path: ":id",
                            name: "supervision_business_review_edit",
                            meta: {
                                title: "業務審核",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/Supervision/SupervisionBusinessReviewEdit.vue"),
                        },],
                    },

                    {
                        path: "assist_checkwork",
                        name: "supervision_assist_checkwork",
                        meta: {
                            title: "查核工作底稿",
                            breadcrumb: "查核工作底稿",
                            submenu: false,
                            subFormKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/Supervision/SupervisionAssistCheckwork.vue"),
                        children: [{
                            path: ":subId",
                            name: "supervision_assist_checkwork_edit",
                            meta: {
                                title: "查核工作底稿編輯",
                                breadcrumb: "查核工作底稿編輯",
                                submenu: false,
                                subIouFormKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/Supervision/SupervisionAssistCheckworkEdit.vue"),
                            children: [{
                                path: "ioureviewid/:iouSubId",
                                name: "super_assist_checkwork_iou_edit",
                                meta: {
                                    title: "查核工作底稿借據編輯",
                                    breadcrumb: "查核工作底稿借據編輯",
                                },
                                component: () =>
                                    import("./views/association/Supervision/SupervisionAssistCheckworkIouEdit.vue"),
                            },],
                        },],
                    },
                    ],
                },
                // 督導組組長
                {
                    path: "supervision_leader",
                    name: "supervision_leader",
                    meta: {
                        title: "業務審核",
                        breadcrumb: "業務審核",
                        listKeepAlive: true,
                    },
                    component: () =>
                        import("./views/association/Supervision/SupervisionBusinessReview.vue"),
                    children: [{
                        path: ":id",
                        name: "supervision_leader_edit",
                        meta: {
                            title: "業務審核",
                            breadcrumb: "編輯",
                            formKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/Supervision/SupervisionBusinessReviewEdit.vue"),
                    },],
                },
            ],
        },
        // 儲互社
        {
            path: "coop",
            meta: {
                title: "儲互社",
            },
            component: () =>
                import("./views/coop/Coop.vue"),
            children: [
                // 人事差勤系統
                {
                    path: "attendance",
                    name: "attendance",
                    meta: {
                        title: "人事差勤首頁",
                        breadcrumb: "人事差勤",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Attendance/Attendance.vue"),
                    children: [{
                        path: "admin",
                        name: "attendance_admin",
                        meta: {
                            title: "使用者帳號管理",
                            breadcrumb: "使用者帳號管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Attendance/CoopAdmin.vue"),
                        children: [{
                            path: ":id",
                            name: "attendance_admin_edit",
                            meta: {
                                title: "基本資料",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/association/System/Admin/AdminEdit.vue"),
                            children: [{
                                path: "role",
                                name: "attendance_admin_role",
                                meta: {
                                    title: "角色設定",
                                    breadcrumb: "角色設定",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/System/Admin/AdminRole.vue"),
                            },
                            // {
                            //     path: 'permission',
                            //     name: 'attendance_admin_permission',
                            //     meta: { title: '權限設定', breadcrumb: '權限設定', submenu: true },
                            //     component: () => import('./views/association/System/Admin/AdminPermission.vue'),
                            // },
                            {
                                path: "loginlog",
                                name: "attendance_admin_loginlog",
                                meta: {
                                    title: "登入紀錄",
                                    breadcrumb: "登入紀錄",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/association/System/Admin/AdminLoginLog.vue"),
                            },
                            ],
                        },],
                    },
                    {
                        path: "leave",
                        name: "leave",
                        meta: {
                            title: "個人請假管理",
                            breadcrumb: "個人請假管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Attendance/Leave.vue"),
                        children: [{
                            path: ":id",
                            name: "leave_edit",
                            meta: {
                                title: "個人請假管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Attendance/LeaveEdit.vue"),
                        },],
                    },
                    {
                        path: "login_log",
                        name: "attendance_login_log",
                        meta: {
                            title: "登入紀錄查詢",
                            breadcrumb: "登入紀錄查詢",
                        },
                        component: () =>
                            import("./views/coop/Attendance/LoginLog.vue"),
                    },
                    {
                        path: "agent_login_log",
                        name: "agent_attendance_login_log",
                        meta: {
                            title: "代理人歷史紀錄查詢",
                            breadcrumb: "代理人歷史紀錄查詢",
                        },
                        component: () =>
                            import("./views/coop/Attendance/AttendanceLoginLog.vue"),
                    },
                    ],
                },
                // 系統管理
                {
                    path: "coop_system",
                    name: "coop_system",
                    meta: {
                        title: "系統管理首頁",
                        breadcrumb: "系統管理",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/System/System.vue"),
                    children: [{
                        path: "parameter",
                        name: "coop_parameter",
                        meta: {
                            title: "作業參數設定",
                            breadcrumb: "作業參數設定",
                            keeplive: true,
                        },
                        component: () =>
                            import("./views/coop/System/Parameter.vue"),
                        children: [{
                            path: "history",
                            name: "coop_parameter_edit",
                            meta: {
                                title: "利率調整紀錄",
                                breadcrumb: "利率調整紀錄",
                            },
                            component: () =>
                                import("./views/coop/System/ParameterEdit.vue"),
                        },],
                    },
                    {
                        path: "review",
                        name: "coop_system_review",
                        meta: {
                            title: "審查作業設定",
                            breadcrumb: "審查作業設定",
                            subListKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/System/Coop/CoopReview.vue"),
                        children: [{
                            path: ":subId",
                            name: "coop_system_review_edit",
                            meta: {
                                title: "審查作業設定",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/association/System/Coop/CoopReviewEdit.vue"),
                        },],
                    },
                    {
                        path: "information",
                        name: "coop_information",
                        meta: {
                            title: "儲互社基本資料管理",
                            breadcrumb: "儲互社基本資料管理",
                            formKeepAlive: true,
                            submenu: true,
                        },
                        redirect: "information/",
                        component: () =>
                            import("./views/association/System/Coop/CoopEdit.vue"),
                        children: [{
                            path: "/",
                            name: "coop_information_edit",
                            meta: {
                                title: "儲互社基本資料管理",
                                breadcrumb: "基本資料",
                                formKeepAlive: true,
                                submenu: true,
                            },
                            component: () =>
                                import("./views/association/System/Coop/CoopEdit.vue"),
                        },
                        {
                            path: "time",
                            name: "coop_information_time",
                            meta: {
                                title: "儲互社營業時間",
                                breadcrumb: "營業時間",
                                subListKeepAlive: true,
                                submenu: true,
                            },
                            component: () =>
                                import("./views/association/System/Coop/CoopTime.vue"),
                        },
                        ],
                    },
                    {
                        path: "accounting",
                        name: "coop_accounting",
                        meta: {
                            title: "會計科目查詢",
                            breadcrumb: "會計科目查詢",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/Accounting.vue"),
                        children: [{
                            path: ":id",
                            name: "coop_accounting_edit",
                            meta: {
                                title: "會計科目查詢",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/System/AccountingEdit.vue"),
                            children: [{
                                path: "review",
                                name: "coop_accounting_review",
                                meta: {
                                    title: "審查",
                                    breadcrumb: "審查",
                                },
                                component: () =>
                                    import("./views/coop/System/AccountingReview.vue"),
                            },],
                        },],
                    },
                    {
                        path: "supervisors",
                        name: "list_supervisors",
                        meta: {
                            title: "歷任選任理監事名單",
                            breadcrumb: "歷任選任理監事名單",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/ListSupervisors.vue"),
                        children: [{
                            path: ":id",
                            name: "list_supervisors_edit",
                            meta: {
                                title: "歷任選任理監事名單",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/ListSupervisorsEdit.vue"),
                        },],
                    },
                    {
                        path: "cadre",
                        name: "list_cadre",
                        meta: {
                            title: "歷屆聘任幹部名單",
                            breadcrumb: "歷屆聘任幹部名單",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/ListCadre.vue"),
                        children: [{
                            path: ":id",
                            name: "list_cadre_edit",
                            meta: {
                                title: "歷屆聘任幹部名單",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/ListCadreEdit.vue"),
                        },],
                    },
                    {
                        path: "meeting_record",
                        name: "meeting_record",
                        meta: {
                            title: "會議記錄管理",
                            breadcrumb: "會議記錄管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/MeetingRecord.vue"),
                        children: [{
                            path: ":id",
                            name: "meeting_record_edit",
                            meta: {
                                title: "會議記錄管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/MeetingRecordEdit.vue"),
                        },],
                    },
                    {
                        path: "hire_employee",
                        name: "hire_employee",
                        meta: {
                            title: "聘僱人員名單",
                            breadcrumb: "聘僱人員名單",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/HireEmployee.vue"),
                        children: [{
                            path: ":id",
                            name: "hire_employee_edit",
                            meta: {
                                title: "聘僱人員名單",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/HireEmployeeEdit.vue"),
                        },],
                    },
                    {
                        path: "chinese_vocabulary",
                        name: "chinese_vocabulary",
                        meta: {
                            title: "中文辭彙建檔資料管理",
                            breadcrumb: "中文辭彙建檔資料管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/ChineseVocabulary.vue"),
                        children: [{
                            path: ":id",
                            name: "chinese_vocabulary_edit",
                            meta: {
                                title: "中文辭彙建檔資料管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/ChineseVocabularyEdit.vue"),
                        },],
                    },
                    {
                        path: "sms_use",
                        name: "sms_use",
                        meta: {
                            title: "簡訊使用管理",
                            breadcrumb: "簡訊使用管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/association/System/SMS/CoopSmsUse.vue"),
                        children: [{
                            path: ":id",
                            name: "sms_use_edit",
                            meta: {
                                title: "簡訊使用管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/association/System/SMS/CoopSmsUseEdit.vue"),
                        },],
                    },
                    {
                        path: "sms_buy",
                        name: "sms_buy",
                        meta: {
                            title: "簡訊購買記錄管理",
                            breadcrumb: "簡訊購買記錄管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/SmsBuy.vue"),
                        children: [{
                            path: ":id",
                            name: "sms_buy_edit",
                            meta: {
                                title: "簡訊購買記錄管理",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/System/SmsBuyEdit.vue"),
                            children: [{
                                path: "directReview",
                                name: "sms_buy_directReview",
                                meta: {
                                    title: "主任審查",
                                    breadcrumb: "主任審查",
                                },
                                component: () =>
                                    import("./views/coop/System/SmsBuyDirectorReview.vue"),
                            },
                            {
                                path: "managerReview",
                                name: "sms_buy_managerReview",
                                meta: {
                                    title: "經理審查",
                                    breadcrumb: "經理審查",
                                },
                                component: () =>
                                    import("./views/coop/System/SmsBuyManagerReview.vue"),
                            },
                            {
                                path: "buyStatus",
                                name: "sms_buy_status",
                                meta: {
                                    title: "購買狀態",
                                    breadcrumb: "購買狀態",
                                },
                                component: () =>
                                    import("./views/coop/System/SmsBuyStatus.vue"),
                            },
                            ],
                        },],
                    },
                    {
                        path: "bank_account",
                        name: "bank_account",
                        meta: {
                            title: "銀行帳戶管理",
                            breadcrumb: "銀行帳戶管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/System/BankAccount.vue"),
                        children: [{
                            path: ":id",
                            name: "bank_account_edit",
                            meta: {
                                title: "銀行帳戶管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/System/BankAccountEdit.vue"),
                        },],
                    },
                    ],
                },
                // 臨櫃作業
                {
                    path: "cabinet",
                    name: "cabinet",
                    meta: {
                        title: "臨櫃作業首頁",
                        breadcrumb: "臨櫃作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Cabinet/Cabinet.vue"),
                    children: [{
                        path: "member",
                        meta: {
                            title: "社員資料管理",
                            breadcrumb: "社員資料",
                        },
                        component: () =>
                            import("./views/coop/Cabinet/MemberHome.vue"),
                        children: [{
                            //社員總帳
                            path: "generalLedger",
                            name: "member_general_ledger",
                            meta: {
                                title: "社員總帳",
                                breadcrumb: "社員總帳",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/GeneralLledger.vue"),
                        },
                        {
                            //個人帳
                            path: "personalAccount",
                            name: "member_personal_account",
                            meta: {
                                title: "股金及放款個人帳",
                                breadcrumb: "股金及放款個人帳",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/PersonalAccounts.vue"),
                        },
                        // 社員群組管理
                        {
                            path: "group",
                            name: "member_group",
                            meta: {
                                title: "社員群組管理",
                                breadcrumb: "社員群組管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/MemberGroup.vue"),
                            children: [{
                                path: ":id",
                                name: "member_group_edit",
                                meta: {
                                    title: "社員群組管理",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/MemberGroupEdit.vue"),
                                children: [{
                                    path: "staff",
                                    name: "member_group_staff",
                                    meta: {
                                        title: "群組人員",
                                        breadcrumb: "群組人員",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberGroupStaff.vue"),
                                },],
                            },],
                        },
                        // 社員資料管理
                        {
                            path: "staff",
                            name: "member",
                            meta: {
                                title: "社員資料管理",
                                breadcrumb: "社員資料管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/Member.vue"),
                            children: [{
                                path: ":id",
                                name: "member_edit",
                                meta: {
                                    title: "社員資料管理",
                                    submenu: true,
                                    formKeepAlive: true,
                                    topbtnCtrol: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/MemberEdit.vue"),
                                children: [{
                                    path: "stakes",
                                    name: "member_stakes",
                                    meta: {
                                        title: "利害關係人",
                                        breadcrumb: "利害關係人",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberStakes.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "member_stakes_edit",
                                        meta: {
                                            title: "利害關係人",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/MemberStakesEdit.vue"),
                                    },],
                                },
                                {
                                    path: "stock",
                                    name: "member_stock",
                                    meta: {
                                        title: "股金管理",
                                        breadcrumb: "股金管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberStock.vue"),
                                },
                                {
                                    path: "transfer",
                                    name: "member_transfer",
                                    meta: {
                                        title: "備轉金管理",
                                        breadcrumb: "備轉金管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberTransfer.vue"),
                                },
                                {
                                    path: "anji",
                                    name: "member_anji",
                                    meta: {
                                        title: "安基管理",
                                        breadcrumb: "安基管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberAnji.vue"),
                                },
                                {
                                    path: "loan",
                                    name: "member_loan",
                                    meta: {
                                        title: "放款管理",
                                        breadcrumb: "放款管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberLoan.vue"),
                                },
                                {
                                    path: "record",
                                    name: "member_record",
                                    meta: {
                                        title: "放款個人帳",
                                        breadcrumb: "放款個人帳",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberRecord.vue"),
                                },
                                {
                                    path: "payroll",
                                    name: "member_payroll",
                                    meta: {
                                        title: "薪資轉帳",
                                        breadcrumb: "薪資轉帳",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberPayroll.vue"),
                                },
                                {
                                    path: "commission",
                                    name: "member_commission",
                                    meta: {
                                        title: "委託轉帳",
                                        breadcrumb: "委託轉帳",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberCommission.vue"),
                                },
                                {
                                    path: "note",
                                    name: "member_note",
                                    meta: {
                                        title: "記事",
                                        breadcrumb: "記事",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberNote.vue"),
                                },
                                {
                                    path: "summons",
                                    name: "member_summons",
                                    meta: {
                                        title: "相關傳票",
                                        breadcrumb: "相關傳票",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberSummons.vue"),
                                },
                                {
                                    path: "six_year",
                                    name: "member_sixyear",
                                    meta: {
                                        title: "六年平儲",
                                        breadcrumb: "六年平儲",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberSixYear.vue"),
                                },
                                {
                                    path: "over_stock",
                                    name: "member_overstock",
                                    meta: {
                                        title: "超額/逾齡股金管理",
                                        breadcrumb: "超額/逾齡股金管理",
                                        subListKeepAlive: true,
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/MemberOverStock.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "member_overstock_edit",
                                        meta: {
                                            title: "超額/逾齡股金管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/MemberOverStockEdit.vue"),
                                    }]
                                },
                                ],
                            },],
                        },
                        // 準社員入社申請資料管理
                        {
                            path: "quasi_join",
                            name: "quasi_member_join",
                            meta: {
                                title: "準社員入社申請資料管理",
                                breadcrumb: "準社員入社申請資料管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/QuasiMemberJoin.vue"),
                            children: [{
                                path: ":id",
                                name: "quasi_member_join_edit",
                                meta: {
                                    title: "上傳入社申請書",
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/QuasiMemberJoinEdit.vue"),
                                children: [{
                                    path: "review",
                                    name: "quasi_member_join_review",
                                    meta: {
                                        title: "審查紀錄",
                                        breadcrumb: "審查紀錄",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/QuasiMemberReview.vue"),
                                },],
                            },
                            {
                                path: "info",
                                name: "quasi_member_join_info",
                                meta: {
                                    title: "輸入準社員資料",
                                    breadcrumb: "輸入準社員資料",
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/QuasiMemberinfo.vue"),
                            },
                            ],
                        },
                        // 準社員資料管理
                        {
                            path: "quasi",
                            name: "quasi_member",
                            meta: {
                                title: "準社員資料管理",
                                breadcrumb: "準社員資料管理",
                                listKeepAlive: true,
                                btnCtl: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/QuasiMember.vue"),
                            children: [{
                                path: ":id",
                                name: "quasi_member_info",
                                meta: {
                                    title: "準社員資料管理",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/QuasiMemberEdit.vue"),
                                children: [{
                                    path: "review",
                                    name: "quasi_member_review",
                                    meta: {
                                        title: "審查紀錄",
                                        breadcrumb: "審查紀錄",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/QuasiMemberReview.vue"),
                                },
                                {
                                    path: "deposit",
                                    name: "quasi_member_deposit",
                                    meta: {
                                        title: "傳票管理",
                                        breadcrumb: "傳票管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/QuasiMemberDeposit.vue"),
                                },
                                ],
                            },],
                        },
                        // 準社員升社員作業
                        {
                            path: "associate",
                            name: "associate_member",
                            meta: {
                                title: "準社員升社員作業",
                                breadcrumb: "準社員升社員作業",
                                listKeepAlive: true,
                                toolbtn: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/AssociateMember.vue"),
                            children: [{
                                path: ":id",
                                name: "associate_member_edit",
                                meta: {
                                    title: "準社員升社員作業",
                                    groupAddMember: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/AssociateMemberEdit.vue"),

                                // children: [{
                                //         path: 'review',
                                //         name: 'associate_member_review',
                                //         meta: { title: '審查作業', breadcrumb: '審查作業', submenu: true },
                                //         component: () => import('./views/coop/Cabinet/AssociateMemberReview.vue'),
                                //     },
                                //     {
                                //         path: 'conversion',
                                //         name: 'associate_member_conversion',
                                //         meta: { title: '準社員資料轉換', breadcrumb: '準社員資料轉換', submenu: true },
                                //         component: () => import('./views/coop/Cabinet/AssociateMemberReview.vue'),
                                //     },                                                // ]
                            },
                            {
                                path: "tranferMember/:id",
                                name: "associate_member_tranferMember",
                                meta: {
                                    title: "準社員升社員作業",
                                    Menu: true,
                                    btnCtl: false,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/TranferMember.vue"),
                            },
                            ],
                        },
                        {
                            path: "quasi_member_personal_report",
                            name: "quasi_member_personal_report",
                            meta: {
                                title: "準社員升社員作業",
                                Menu: true,
                                btnCtl: false,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/QuasiMemberPersonalReport.vue"),
                        },
                        {
                            path: "quasi_member_to_member_list",
                            name: "quasi_member_to_member_list",
                            meta: {
                                title: "準社員升社員作業",
                                Menu: true,
                                btnCtl: false,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/QuasiMemberToMemberList.vue"),
                        },
                        // 退社管理
                        {
                            path: "drop_out",
                            name: "member_drop_out",
                            meta: {
                                title: "退社管理",
                                breadcrumb: "退社管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/DropOutList.vue"),
                            children: [{
                                path: ":id",
                                name: "member_drop_out_edit",
                                meta: {
                                    title: "退社申請",
                                    breadcrumb: "退社申請",
                                    keeplive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/DropOutEdit.vue"),
                                children: [
                                    // {
                                    //     path: 'application',
                                    //     name: 'member_drop_out_application',
                                    //     meta: { title: '退社申請', breadcrumb: '退社申請', },
                                    //     component: () => import('./views/coop/Cabinet/DropOutApplication.vue'),
                                    // },
                                    {
                                        path: "director_review",
                                        name: "member_drop_out_director_review",
                                        meta: {
                                            title: "主任審查",
                                            breadcrumb: "主任審查",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutDirectorReview.vue"),
                                    },
                                    {
                                        path: "manager_review",
                                        name: "member_drop_out_manager_review",
                                        meta: {
                                            title: "經理審查",
                                            breadcrumb: "經理審查",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutManagerReview.vue"),
                                    },
                                    {
                                        path: "council_review",
                                        name: "member_drop_out_council_review",
                                        meta: {
                                            title: "理事會審查",
                                            breadcrumb: "理事會審查",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutCouncilReview.vue"),
                                    },
                                    {
                                        path: "culroc_suspension",
                                        name: "member_drop_out_culroc_suspension",
                                        meta: {
                                            title: "互助基金退保作業",
                                            breadcrumb: "互助基金退保作業",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutCulrocSuspension.vue"),
                                    },
                                    {
                                        path: "settle_loan",
                                        name: "member_drop_out_settle_loan",
                                        meta: {
                                            title: "貸款結清作業",
                                            breadcrumb: "貸款結清作業",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutSettleLoan.vue"),
                                    },
                                    {
                                        path: "lpls_claim",
                                        name: "member_drop_out_lpls_claim",
                                        meta: {
                                            title: "LPLS 理賠申請",
                                            breadcrumb: "LPLS 理賠申請",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutLPLSClaim.vue"),
                                    },
                                    {
                                        path: "settle_stock",
                                        name: "member_drop_out_settle_stock",
                                        meta: {
                                            title: "股金備轉金結清作業",
                                            breadcrumb: "股金備轉金結清作業",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutSettleStock.vue"),
                                    },
                                    {
                                        path: "upload_file",
                                        name: "member_drop_out_upload_file",
                                        meta: {
                                            title: "上傳退社申請書掃描檔",
                                            breadcrumb: "上傳退社申請書掃描檔",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/DropOutUploadFile.vue"),
                                    },
                                ],
                            },],
                        },
                        // 社員轉出管理
                        {
                            path: "transfer_out",
                            name: "transfer_out",
                            meta: {
                                title: "社員轉出管理",
                                breadcrumb: "社員轉出管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/TransferOut.vue"),
                            children: [{
                                path: ":id",
                                name: "transfer_out_edit",
                                meta: {
                                    title: "轉社申請",
                                    breadcrumb: "轉社申請",
                                    keeplive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/TransferOutEdit.vue"),
                                children: [{
                                    path: "director_review",
                                    name: "transfer_out_director_review",
                                    meta: {
                                        title: "主任審查",
                                        breadcrumb: "主任審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutDirectorReview.vue"),
                                },
                                {
                                    path: "manager_review",
                                    name: "transfer_out_manager_review",
                                    meta: {
                                        title: "經理審查",
                                        breadcrumb: "經理審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutManagerReview.vue"),
                                },
                                {
                                    path: "council_review",
                                    name: "transfer_out_council_review",
                                    meta: {
                                        title: "理事會審查",
                                        breadcrumb: "理事會審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutCouncilReview.vue"),
                                },
                                {
                                    path: "coop_review",
                                    name: "transfer_out_coop_review",
                                    meta: {
                                        title: "轉入社審查",
                                        breadcrumb: "轉入社審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutCoopReview.vue"),
                                },
                                {
                                    path: "culroc_suspension",
                                    name: "transfer_out_culroc_suspension",
                                    meta: {
                                        title: "互助基金退保作業",
                                        breadcrumb: "互助基金退保作業",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutCulrocSuspension.vue"),
                                },
                                {
                                    path: "loan_settlement",
                                    name: "transfer_out_loan_settlement",
                                    meta: {
                                        title: "貸款結清作業",
                                        breadcrumb: "貸款結清作業",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutLoanSettlement.vue"),
                                },
                                {
                                    path: "transfer",
                                    name: "transfer_out_transfer",
                                    meta: {
                                        title: "社員資料轉換",
                                        breadcrumb: "社員資料轉換",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutTransfer.vue"),
                                },
                                {
                                    path: "settle_stock",
                                    name: "transfer_out_settle_stock",
                                    meta: {
                                        title: "貸款結清作業",
                                        breadcrumb: "貸款結清作業",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferOutSettleStock.vue"),
                                },
                                ],
                            },],
                        },
                        // 社員轉入管理
                        {
                            path: "transfer_in",
                            name: "transfer_in",
                            meta: {
                                title: "社員轉入管理",
                                breadcrumb: "社員轉入管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/TransferIn.vue"),
                            children: [{
                                path: ":id",
                                name: "transfer_in_edit",
                                meta: {
                                    title: "轉入社員申請資料",
                                    breadcrumb: "轉入社員申請資料",
                                    keeplive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/TransferInEdit.vue"),
                                children: [{
                                    path: "director_review",
                                    name: "transfer_in_director_review",
                                    meta: {
                                        title: "主任審查",
                                        breadcrumb: "主任審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferInDirectorReview.vue"),
                                },
                                {
                                    path: "manager_review",
                                    name: "transfer_in_manager_review",
                                    meta: {
                                        title: "經理審查",
                                        breadcrumb: "經理審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferInManagerReview.vue"),
                                },
                                {
                                    path: "council_review",
                                    name: "transfer_in_council_review",
                                    meta: {
                                        title: "理事會審查",
                                        breadcrumb: "理事會審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferInCouncilReview.vue"),
                                },
                                {
                                    path: "member",
                                    name: "transfer_in_member",
                                    meta: {
                                        title: "建立社員帳號",
                                        breadcrumb: "建立社員帳號",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferInMember.vue"),
                                },
                                {
                                    path: "fee",
                                    name: "transfer_in_fee",
                                    meta: {
                                        title: "收取入社費",
                                        breadcrumb: "收取入社費",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/TransferInFee.vue"),
                                },
                                ],
                            },],
                        },
                        // 退股金管理
                        {
                            path: "withdrawal",
                            name: "withdrawal",
                            meta: {
                                title: "退股管理",
                                breadcrumb: "退股管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/Withdrawal.vue"),
                            children: [{
                                path: ":id",
                                name: "withdrawal_edit",
                                meta: {
                                    title: "退股申請",
                                    breadcrumb: "退股申請",
                                    keeplive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/WithdrawalEdit.vue"),
                                children: [{
                                    path: "director_review",
                                    name: "withdrawal_director_review",
                                    meta: {
                                        title: "主任審查",
                                        breadcrumb: "主任審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/WithdrawalDirectorReview.vue"),
                                },
                                {
                                    path: "manager_review",
                                    name: "withdrawal_manager_review",
                                    meta: {
                                        title: "經理審查",
                                        breadcrumb: "經理審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/WithdrawalManagerReview.vue"),
                                },
                                {
                                    path: "council_review",
                                    name: "withdrawal_council_review",
                                    meta: {
                                        title: "理事會審查",
                                        breadcrumb: "理事會審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/WithdrawalCouncilReview.vue"),
                                },
                                {
                                    path: "upload_file",
                                    name: "withdrawal_upload_file",
                                    meta: {
                                        title: "上傳退股申請書掃描檔",
                                        breadcrumb: "上傳退股申請書掃描檔",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/WithdrawalUploadFile.vue"),
                                },
                                ],
                            },],
                        },
                        // 備轉金個人帳
                        {
                            path: "member_shares_report",
                            name: "member_shares_report",
                            meta: {
                                title: "備轉金個人帳",
                                breadcrumb: "備轉金個人帳",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/MemberSharesReport.vue"),
                        },
                        ],
                    },
                    // 台幣定存單管理
                    {
                        path: "deposit_order",
                        name: "deposit_order",
                        meta: {
                            title: "台幣定存單管理",
                            breadcrumb: "台幣定存單管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cabinet/DepositOrder.vue"),
                        children: [{
                            path: ":id",
                            name: "deposit_order_edit",
                            meta: {
                                title: "台幣定存單管理",
                                submenu: "台幣定存單管理",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/DepositOrderEdit.vue"),
                            children: [{
                                path: "summons",
                                name: "deposit_order_summons",
                                meta: {
                                    title: "相關傳票",
                                    breadcrumb: "相關傳票",
                                    submenu: true,
                                    subFormKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/DepositOrderSummons.vue"),
                                children: [{
                                    path: "continue",
                                    name: "deposit_order_summons_continue",
                                    meta: {
                                        title: "續存作業",
                                        breadcrumb: "續存作業",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/DepositOrderSummonsContinue.vue"),
                                },],
                            },],
                        },],
                    },
                    // 零用金備查簿(未使用)
                    {
                        path: "cash_reference",
                        name: "cash_reference",
                        meta: {
                            title: "零用金備查簿",
                            breadcrumb: "零用金備查簿",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cabinet/CashReference.vue"),
                        children: [{
                            path: ":id",
                            name: "cash_reference_edit",
                            meta: {
                                title: "零用金備查簿",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/CashReferenceEdit.vue"),
                        },],
                    },
                    // 資料查印
                    {
                        path: "print",
                        name: "print",
                        meta: {
                            title: "資料查印",
                            breadcrumb: "資料查印",
                        },
                        component: () =>
                            import("./views/coop/Cabinet/print/Print.vue"),
                        children: [{
                            path: "loan_interest",
                            name: "loan_interest",
                            meta: {
                                title: "放款本息",
                                breadcrumb: "放款本息",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/LoanInterest.vue"),
                        },
                        {
                            path: "due_interest",
                            name: "due_interest",
                            meta: {
                                title: "到期應還本息",
                                breadcrumb: "到期應還本息",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/DueInterest.vue"),
                        },
                        {
                            path: "loan_overdue",
                            name: "loan_overdue",
                            meta: {
                                title: "放款逾期一覽表",
                                breadcrumb: "放款逾期一覽表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/LoanOverdue.vue"),
                        },
                        {
                            path: "loan_overdue_colt_list",
                            name: "loan_overdue_colt_list",
                            meta: {
                                title: "放款催收明細表",
                                breadcrumb: "放款催收明細表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/LoanOverdueColtList.vue"),
                        },
                        {
                            path: "loan_list",
                            name: "loan_list",
                            meta: {
                                title: "放款一覽表",
                                breadcrumb: "放款一覽表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/LoanList.vue"),
                        },
                        {
                            path: "loan_agreement",
                            name: "loan_agreement",
                            meta: {
                                title: "放款協議清單",
                                breadcrumb: "放款協議清單",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/LoanAgreement.vue"),
                        },
                        {
                            path: "agreement_repayment",
                            name: "agreement_repayment",
                            meta: {
                                title: "約定償還協議清單",
                                breadcrumb: "約定償還協議清單",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/AgreementRepayment.vue"),
                        },
                        {
                            path: "personal_loan",
                            name: "personal_loan",
                            meta: {
                                title: "個人貸款資料",
                                breadcrumb: "個人貸款資料",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/PersonalLoan.vue"),
                        },
                        {
                            path: "repayment_record",
                            name: "repayment_record",
                            meta: {
                                title: "借據還款紀錄表",
                                breadcrumb: "借據還款紀錄表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/RepaymentRecord.vue"),
                        },
                        {
                            path: "schedule_repayment",
                            name: "schedule_repayment",
                            meta: {
                                title: "預定還款表",
                                breadcrumb: "預定還款表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/ScheduleRepayment.vue"),
                        },
                        {
                            path: "onethree_schedule",
                            name: "onethree_schedule",
                            meta: {
                                title: "放款逾期１至３個月明細表",
                                breadcrumb: "放款逾期１至３個月明細表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/OnethreeSchedule.vue"),
                        },
                        {
                            path: "guarantor_search",
                            name: "guarantor_search",
                            meta: {
                                title: "保證人查詢",
                                breadcrumb: "保證人查詢",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/GuarantorSearch.vue"),
                        },
                        {
                            path: "member_roster",
                            name: "member_roster",
                            meta: {
                                title: "社員名冊",
                                breadcrumb: "社員名冊",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/MemberRoster.vue"),
                        },
                        {
                            path: "cadre_roster",
                            name: "cadre_roster",
                            meta: {
                                title: "幹部名冊",
                                breadcrumb: "幹部名冊",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/CadreRoster.vue"),
                        },
                        {
                            path: "zipcode_label",
                            name: "zipcode_label",
                            meta: {
                                title: "郵遞標籤",
                                breadcrumb: "郵遞標籤",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/ZipcodeLabel.vue"),
                        },
                        {
                            path: "month_birthday",
                            name: "month_birthday",
                            meta: {
                                title: "月份壽星",
                                breadcrumb: "月份壽星",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/MonthBirthday.vue"),
                        },
                        {
                            path: "repayment_calc",
                            name: "repayment_calc",
                            meta: {
                                title: "定額/還款試算",
                                breadcrumb: "定額/還款試算",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/RepaymentCalc.vue"),
                        },
                        {
                            path: "interest_comparison",
                            name: "interest_comparison",
                            meta: {
                                title: "貸放利息應收實收比較表",
                                breadcrumb: "貸放利息應收實收比較表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/InterestComparison.vue"),
                        },
                        {
                            path: "no_deposit",
                            name: "no_deposit",
                            meta: {
                                title: "當月未存款名單",
                                breadcrumb: "當月未存款名單",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/NoDeposit.vue"),
                        },
                        {
                            path: "no_paid",
                            name: "no_paid",
                            meta: {
                                title: "應還未還款名單",
                                breadcrumb: "應還未還款名單",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/NoPaid.vue"),
                        },
                        {
                            path: "inout_list",
                            name: "inout_list",
                            meta: {
                                title: "入社退社名單",
                                breadcrumb: "入社退社名單",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/InoutList.vue"),
                        },
                        {
                            path: "member_checklist",
                            name: "member_checklist",
                            meta: {
                                title: "社員簽到簿",
                                breadcrumb: "社員簽到簿",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/MemberChecklist.vue"),
                        },
                        {
                            path: "stocks_attendance",
                            name: "stocks_attendance",
                            meta: {
                                title: "股金全勤表",
                                breadcrumb: "股金全勤表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/StocksAttendance.vue"),
                        },
                        {
                            path: "repayment_form",
                            name: "repayment_form",
                            meta: {
                                title: "還款表",
                                breadcrumb: "還款表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/RepaymentForm.vue"),
                        },
                        {
                            path: "balance_ranking",
                            name: "balance_ranking",
                            meta: {
                                title: "各項結餘排行",
                                breadcrumb: "各項結餘排行",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/BalanceRanking.vue"),
                        },
                        {
                            path: "age_analysis",
                            name: "age_analysis",
                            meta: {
                                title: "年齡分析表",
                                breadcrumb: "年齡分析表",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/AgeAnalysis.vue"),
                        },
                        {
                            path: "dead_deal_record",
                            name: "dead_deal_record",
                            meta: {
                                title: "呆帳沖銷紀錄",
                                breadcrumb: "呆帳沖銷紀錄",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/print/DeadDealRecord.vue"),
                        }
                        ],
                    },
                    // 社員轉帳備忘錄有以下兩種入口
                    // 1. 全社，臨櫃作業左側選單 cabinet_transfer
                    // 2. 個人，社員搜尋個人資料 cabinet_member_transfer
                    {
                        path: "transfer",
                        name: "cabinet_transfer_all",
                        meta: {
                            title: "社員轉帳備忘錄",
                            breadcrumb: "社員轉帳備忘錄",
                            subListKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cabinet/CabinetTransfer.vue"),
                        children: [{
                            path: ":subId/summons",
                            name: "cabinet_transfer_summons",
                            meta: {
                                title: "轉帳傳票",
                                breadcrumb: "轉帳傳票",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cabinet/CabinetTransferSummons.vue"),
                            children: [{
                                path: "print",
                                name: "cabinet_transfer_summons_print",
                                meta: {
                                    title: "交易明細核對",
                                    breadcrumb: "交易明細核對",
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetTransferSummonsPrint.vue"),
                            },],
                        },
                        {
                            path: ":subId",
                            name: "cabinet_transfer_detail",
                            meta: {
                                title: "交易明細核對",
                                breadcrumb: "交易明細核對",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/CabinetTransferDetail.vue"),
                        },
                        {
                            path: "summons_print",
                            name: "cabinet_transfer_print",
                            meta: {
                                title: "轉帳傳票",
                                breadcrumb: "轉帳傳票列印",
                            },
                            component: () =>
                                import("./views/coop/Cabinet/CabinetTransferSummonsPrint.vue"),
                        },
                        ],
                    },
                    // 社員搜尋
                    {
                        path: "search",
                        name: "cabinet_search",
                        meta: {
                            title: "社員搜尋",
                            breadcrumb: "社員搜尋",
                        },
                        component: () =>
                            import("./views/coop/Cabinet/CabinetSearch.vue"),
                    },
                    // 臨櫃作業首頁
                    {
                        path: ":id",
                        name: "cabinet_edit",
                        meta: {
                            title: "臨櫃作業首頁",
                            breadcrumb: "臨櫃作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cabinet/CabinetEdit.vue"),
                        children: [
                            // 現金收款作業
                            {
                                path: "cash",
                                name: "cabinet_cash",
                                meta: {
                                    title: "現金收款作業",
                                    breadcrumb: "現金收款作業",
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetCash.vue"),
                            },
                            {
                                path: "printReport",
                                name: "cabinet_printReport",
                                meta: {
                                    title: "現金收款作業",
                                    breadcrumb: "現金收款作業",
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetCashPrintReport.vue"),
                            },
                            //還款試算
                            {
                                path: "Repayment",
                                name: "Repayment_trial",
                                meta: {
                                    title: "還款試算",
                                    breadcrumb: "還款試算",
                                    tria: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/MemberRepayment.vue"),
                            },
                            // 社員轉帳備忘錄
                            {
                                path: "transfer",
                                name: "cabinet_transfer",
                                meta: {
                                    title: "社員轉帳備忘錄",
                                    breadcrumb: "社員轉帳備忘錄",
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetTransfer.vue"),
                                // 社員轉帳備忘錄有兩個入口，底下子頁共用同一批元件：
                                //   cabinet_transfer_all 選單進入，/cabinet/transfer      不帶社員
                                //   cabinet_transfer     臨櫃社員頁進入，/cabinet/:id/transfer
                                // 兩組子路由名稱必須各自獨立。同名時 vue-router 只會保留先註冊的
                                // 那組(cabinet_transfer_all)，用 name 導頁就會掉到不帶 :id 的路徑、
                                // 社員情境遺失，返回鍵也會跳回全社列表
                                children: [{
                                    path: ":subId/summons",
                                    name: "cabinet_member_transfer_summons",
                                    meta: {
                                        title: "轉帳傳票",
                                        breadcrumb: "轉帳傳票",
                                        formKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/CabinetTransferSummons.vue"),
                                    children: [{
                                        path: "print",
                                        name: "cabinet_member_transfer_summons_print",
                                        meta: {
                                            title: "交易明細核對",
                                            breadcrumb: "交易明細核對",
                                        },
                                        component: () =>
                                            import("./views/coop/Cabinet/CabinetTransferSummonsPrint.vue"),
                                    },],
                                },
                                {
                                    path: ":subId",
                                    name: "cabinet_member_transfer_detail",
                                    meta: {
                                        title: "交易明細核對",
                                        breadcrumb: "交易明細核對",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/CabinetTransferDetail.vue"),
                                },
                                {
                                    path: "summons_print",
                                    name: "cabinet_member_transfer_print",
                                    meta: {
                                        title: "轉帳傳票",
                                        breadcrumb: "轉帳傳票列印",
                                    },
                                    component: () =>
                                        import("./views/coop/Cabinet/CabinetTransferSummonsPrint.vue"),
                                },
                                ],
                            },
                            {
                                path: "stockpassbook",
                                name: "cabinet_stock_passbook",
                                meta: {
                                    title: "股金存摺列印",
                                    breadcrumb: "股金存摺列印",
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetStockPassBook.vue"),
                                // children: [{
                                //     path: 'summons',
                                //     name: 'cabinet_transfer_summons',
                                //     meta: { title: '轉帳傳票', breadcrumb: '轉帳傳票' },
                                //     component: () => import('./views/coop/Cabinet/CabinetTransferSummons.vue'),
                                // }, {
                                //     path: ':subId',
                                //     name: 'cabinet_transfer_detail',
                                //     meta: { title: '交易明細核對', breadcrumb: '交易明細核對' },
                                //     component: () => import('./views/coop/Cabinet/CabinetTransferDetail.vue'),
                                // },
                                // {
                                //     path: 'summons_print',
                                //     name: 'cabinet_transfer_print',
                                //     meta: { title: '轉帳傳票', breadcrumb: '轉帳傳票列印' },
                                //     component: () => import('./views/coop/Cabinet/CabinetTransferSummonsPrint.vue'),
                                // }

                                // ]
                            },
                            {
                                path: "transferpassbook",
                                name: "cabinet_transfer_passbook",
                                meta: {
                                    title: "備轉金存摺列印",
                                    breadcrumb: "備轉金存摺列印",
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetTransferPassBook.vue"),
                            },
                            {
                                path: "savingpassbook",
                                name: "cabinet_saving_passbook",
                                meta: {
                                    title: "儲金存摺列印",
                                    breadcrumb: "儲金存摺列印",
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Cabinet/CabinetSavingPassBook.vue"),
                            },
                        ],
                    },
                    ],
                },
                // 安基作業
                {
                    path: "anji",
                    name: "anji",
                    meta: {
                        title: "安基作業首頁",
                        breadcrumb: "安基作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Anji/Anji.vue"),
                    children: [
                        // LPLS
                        {
                            path: "lpls",
                            meta: {
                                title: "LPLS",
                                breadcrumb: "LPLS",
                            },
                            component: () =>
                                import("./views/coop/Anji/LPLS/LPLS.vue"),
                            children: [{
                                path: "start",
                                name: "start",
                                meta: {
                                    title: "開辦查詢",
                                    breadcrumb: "開辦查詢",
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/Start.vue"),
                                children: [{
                                    path: "paper",
                                    name: "start_paper",
                                    meta: {
                                        title: "協會上傳文件",
                                        breadcrumb: "協會上傳文件",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/LPLS/StartPaper.vue"),
                                },],
                            },
                            {
                                path: "StartHistory",
                                name: "StartHistory",
                                meta: {
                                    title: "歷史紀錄",
                                    breadcrumb: "歷史紀錄",
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/StartHistory.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "Start_History_Edit",
                                    meta: {
                                        title: "編輯",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/LPLS/StartHistoryEdit.vue"),
                                },],
                            },
                            {
                                path: "claim_application",
                                name: "claim_application",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "理賠申請管理",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/ClaimApplication.vue"),
                                children: [{
                                    path: ":id",
                                    name: "claim_application_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/LPLS/ClaimApplicationEdit.vue"),
                                    children: [{
                                        path: "inquire",
                                        name: "claim_application_inquire",
                                        meta: {
                                            title: "查詢理賠申請",
                                            breadcrumb: "查詢",
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/LPLS/ClaimApplicationInquire.vue"),
                                    },],
                                },],
                            },
                            {
                                path: "report",
                                name: "lpls_report",
                                meta: {
                                    title: "LPLS申報表明細報表",
                                    breadcrumb: "LPLS申報表明細報表",
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/LPLSReport.vue"),
                            },
                            {
                                path: "claim_personal",
                                name: "lpls_claim_personal",
                                meta: {
                                    title: "LPLS理賠個人帳資料匯出(平民銀行專案用)",
                                    breadcrumb: "LPLS理賠個人帳資料匯出(平民銀行專案用)",
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/LPLSClaimPersonal.vue"),
                            },
                            {
                                path: "detail_statement",
                                name: "lpls_detail_statement",
                                meta: {
                                    title: "LPLS明細對帳單",
                                    breadcrumb: "LPLS明細對帳單",
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/LplsDetailStatement.vue"),
                            },
                            {
                                path: "mutual_detail",
                                name: "lpls_mutual_detail",
                                meta: {
                                    title: "LPLS互助費明細表",
                                    breadcrumb: "LPLS互助費明細表",
                                },
                                component: () =>
                                    import("./views/coop/Anji/LPLS/LPLSMutualDetail.vue"),
                            },


                            ],
                        },
                        // BOND
                        {
                            path: "bond",
                            meta: {
                                title: "BOND",
                                breadcrumb: "BOND",
                            },
                            component: () =>
                                import("./views/coop/Anji/BOND/BOND.vue"),
                            children: [{
                                path: "renew",
                                name: "renew_bond",
                                meta: {
                                    title: "年度續約申請",
                                    breadcrumb: "年度續約申請",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/BOND/RenewBOND"),
                                children: [{
                                    path: "edit/:id",
                                    name: "renew_bond_edit",
                                    meta: {
                                        title: "年度續約申請",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/RenewBONDEdit.vue"),
                                },
                                {
                                    path: "view/:id",
                                    name: "renew_bond_view",
                                    meta: {
                                        title: "年度續約申請",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/RenewBondReview.vue"),
                                },
                                {
                                    path: "cancel",
                                    name: "renew_bond_cancel",
                                    meta: {
                                        title: "年度續約申請",
                                        breadcrumb: "異動申請",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/RenewBondCancel.vue"),
                                },
                                ],
                            },
                            {
                                path: "history",
                                name: "bond_history",
                                meta: {
                                    title: "歷史紀錄查詢",
                                    breadcrumb: "歷史紀錄查詢",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/BOND/BONDHistory.vue"),
                                children: [{
                                    path: ":id",
                                    name: "bond_history_view",
                                    meta: {
                                        title: "歷史紀錄查詢",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/BONDHistoryView.vue"),
                                },],
                            },
                            {
                                path: "claim",
                                name: "bond_claim",
                                meta: {
                                    title: "理賠申請",
                                    breadcrumb: "理賠申請",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/BOND/BONDClaim.vue"),
                                children: [{
                                    path: "A/:id",
                                    name: "bond_claim_edit_A",
                                    meta: {
                                        title: "理賠申請",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/BONDClaimEditA.vue"),
                                },
                                {
                                    path: "B/:id",
                                    name: "bond_claim_edit_B",
                                    meta: {
                                        title: "理賠申請",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/BOND/BONDClaimEditB.vue"),
                                },
                                ],
                            },
                            ],
                        },
                        // 協會待辦互助基金
                        {
                            path: "agent",
                            name: "agent",
                            meta: {
                                title: "協會代辦互助基金",
                                breadcrumb: "協會代辦互助基金",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Anji/Agent/Agent.vue"),
                            children: [{
                                path: ":code",
                                name: "agent_edit",
                                meta: {
                                    title: "協會代辦互助基金",
                                    submenu: true,
                                    formKeepAlive: true,
                                    changeBreadcrumb: true
                                },
                                component: () =>
                                    import("./views/coop/Anji/Agent/AgentEdit.vue"),
                                children: [{
                                    path: "mutual",
                                    name: "agent_mutual",
                                    meta: {
                                        title: "互助費與經辦費明細",
                                        breadcrumb: "互助費與經辦費明細",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentMutual.vue"),
                                },
                                {
                                    path: "paper",
                                    name: "agent_paper",
                                    meta: {
                                        title: "相關文件",
                                        breadcrumb: "相關文件",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentPaper.vue"),
                                },
                                {
                                    path: "executive_roster",
                                    name: "agent_executiveroster",
                                    meta: {
                                        title: "執行中名冊管理",
                                        breadcrumb: "執行中名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentExecutiveRoster.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_executiveroster_edit",
                                        meta: {
                                            title: "執行中名冊管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentExecutiveRosterEdit.vue"),
                                    },],
                                },
                                {
                                    path: "plus_roster",
                                    name: "agent_plusroster",
                                    meta: {
                                        title: "加保申請名冊管理",
                                        breadcrumb: "加保申請名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentRoster.vue"),
                                    children: [{
                                        path: "renew/:year",
                                        name: "agent_plusroster_renew",
                                        meta: {
                                            title: "匯入續約名冊",
                                            breadcrumb: "匯入續約名冊",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentRosterRenew.vue"),
                                    },
                                    {
                                        path: ":subId",
                                        name: "agent_plusroster_edit",
                                        meta: {
                                            title: "加保申請名冊管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentRosterEdit.vue"),
                                    },
                                    ],
                                },
                                {
                                    path: "surrender_roster",
                                    name: "agent_surrenderroster",
                                    meta: {
                                        title: "退保申請名冊管理",
                                        breadcrumb: "退保申請名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/SurrenderRoster.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_surrenderroster_edit",
                                        meta: {
                                            title: "退保申請名冊管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/SurrenderRosterEdit.vue"),
                                    },],
                                },
                                {
                                    path: "agent_merge",
                                    name: "agent_merge",
                                    meta: {
                                        title: "加退保合併送件管理",
                                        breadcrumb: "加退保合併送件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentMerge.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_merge_edit",
                                        meta: {
                                            title: "加退保合併送件管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentMergeEdit.vue"),
                                    },],
                                },
                                {
                                    path: "change_roster",
                                    name: "agent_changeroster",
                                    meta: {
                                        title: "資料變更申請名冊管理",
                                        breadcrumb: "資料變更申請名冊管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/ChangeRoster.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_changeroster_edit",
                                        meta: {
                                            title: "資料變更申請名冊管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/ChangeRosterEdit.vue"),
                                    },],
                                },
                                {
                                    path: "change_merge",
                                    name: "agent_changemerge",
                                    meta: {
                                        title: "資料變更合併送件管理",
                                        breadcrumb: "資料變更合併送件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentMerge.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_changemerge_edit",
                                        meta: {
                                            title: "資料變更合併送件管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentMergeEdit.vue"),
                                    },],
                                },
                                {
                                    path: "agent_claim",
                                    name: "agent_claim",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "理賠申請管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentClaim.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "agent_claim_edit",
                                        meta: {
                                            title: "理賠申請管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Anji/Agent/AgentClaimEdit.vue"),
                                    },],
                                },
                                {
                                    path: "agent_accounting",
                                    name: "agent_accounting",
                                    meta: {
                                        title: "帳務處理",
                                        breadcrumb: "帳務處理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Agent/AgentAccounting.vue"),
                                },
                                ],
                            },],
                        },
                        // 儲互社幹部互助基金
                        {
                            path: "cadre",
                            name: "cadrecoop",
                            meta: {
                                title: "幹部互助基金",
                                breadcrumb: "幹部互助基金",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Anji/Cadre/Cadre.vue"),
                            children: [{
                                path: "paper",
                                name: "cadrecoop_paper",
                                meta: {
                                    title: "相關文件",
                                    breadcrumb: "相關文件",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadrePaper.vue"),
                            },
                            {
                                path: "executive_roster",
                                name: "cadrecoop_executiveroster",
                                meta: {
                                    title: "執行中名冊管理",
                                    breadcrumb: "執行中名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreExecutiveRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_executiveroster_edit",
                                    meta: {
                                        title: "執行中名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreExecutiveRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "plus_roster",
                                name: "cadrecoop_plusroster",
                                meta: {
                                    title: "加保申請名冊管理",
                                    breadcrumb: "加保申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_plusroster_edit",
                                    meta: {
                                        title: "加保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "surrender_roster",
                                name: "cadrecoop_surrenderroster",
                                meta: {
                                    title: "退保申請名冊管理",
                                    breadcrumb: "退保申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreSurrenderRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_surrenderroster_edit",
                                    meta: {
                                        title: "退保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreSurrenderRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "cadrecoop_merge",
                                name: "cadrecoop_merge",
                                meta: {
                                    title: "加退保合併送件管理",
                                    breadcrumb: "加退保合併送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreMerge.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_merge_edit",
                                    meta: {
                                        title: "加退保合併送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreMergeEdit.vue"),
                                },],
                            },
                            {
                                path: "change_roster",
                                name: "cadrecoop_changeroster",
                                meta: {
                                    title: "資料變更申請名冊管理",
                                    breadcrumb: "資料變更申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreChangeRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_changeroster_edit",
                                    meta: {
                                        title: "資料變更申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreChangeRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "change_merge",
                                name: "cadrecoop_changemerge",
                                meta: {
                                    title: "資料變更合併送件管理",
                                    breadcrumb: "資料變更合併送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreMerge.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_changemerge_edit",
                                    meta: {
                                        title: "資料變更合併送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreMergeEdit.vue"),
                                },],
                            },
                            {
                                path: "cadrecoop_claim",
                                name: "cadrecoop_claim",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "理賠申請管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Cadre/CadreClaim.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "cadrecoop_claim_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Cadre/CadreClaimEdit.vue"),
                                },],
                            },
                            ],
                        },
                        // 儲互社員工福利團體保險
                        {
                            path: "employee",
                            name: "employeecoop",
                            meta: {
                                title: "員工福利團體保險",
                                breadcrumb: "員工福利團體保險",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Anji/Employee/Employee.vue"),
                            children: [{
                                path: "paper",
                                name: "employeecoop_paper",
                                meta: {
                                    title: "相關文件",
                                    breadcrumb: "相關文件",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeePaper.vue"),
                            },
                            {
                                path: "executive_roster",
                                name: "employeecoop_executiveroster",
                                meta: {
                                    title: "執行中名冊管理",
                                    breadcrumb: "執行中名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeExecutiveRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_executiveroster_edit",
                                    meta: {
                                        title: "執行中名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeExecutiveRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "plus_roster",
                                name: "employeecoop_plusroster",
                                meta: {
                                    title: "加保申請名冊管理",
                                    breadcrumb: "加保申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_plusroster_edit",
                                    meta: {
                                        title: "加保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "surrender_roster",
                                name: "employeecoop_surrenderroster",
                                meta: {
                                    title: "退保申請名冊管理",
                                    breadcrumb: "退保申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeSurrenderRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_surrenderroster_edit",
                                    meta: {
                                        title: "退保申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeSurrenderRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "employeecoop_merge",
                                name: "employeecoop_merge",
                                meta: {
                                    title: "加退保合併送件管理",
                                    breadcrumb: "加退保合併送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeMerge.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_merge_edit",
                                    meta: {
                                        title: "加退保合併送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeMergeEdit.vue"),
                                },],
                            },
                            {
                                path: "change_roster",
                                name: "employeecoop_changeroster",
                                meta: {
                                    title: "資料變更申請名冊管理",
                                    breadcrumb: "資料變更申請名冊管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeChangeRoster.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_changeroster_edit",
                                    meta: {
                                        title: "資料變更申請名冊管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeChangeRosterEdit.vue"),
                                },],
                            },
                            {
                                path: "change_merge",
                                name: "employeecoop_changemerge",
                                meta: {
                                    title: "資料變更合併送件管理",
                                    breadcrumb: "資料變更合併送件管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeMerge.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_changemerge_edit",
                                    meta: {
                                        title: "資料變更合併送件管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeMergeEdit.vue"),
                                },],
                            },
                            {
                                path: "employeecoop_claim",
                                name: "employeecoop_claim",
                                meta: {
                                    title: "理賠申請管理",
                                    breadcrumb: "理賠申請管理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeClaim.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "employeecoop_claim_edit",
                                    meta: {
                                        title: "理賠申請管理",
                                        breadcrumb: "編輯",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/Employee/EmployeeClaimEdit.vue"),
                                },],
                            },
                            {
                                path: "employeecoop_accounting",
                                name: "employeecoop_accounting",
                                meta: {
                                    title: "帳務處理",
                                    breadcrumb: "帳務處理",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/Employee/EmployeeAccounting.vue"),
                            },
                            ],
                        },
                        // 六年平儲
                        {
                            path: "six_year",
                            meta: {
                                title: "六年平儲",
                                breadcrumb: "六年平儲",
                            },
                            component: () =>
                                import("./views/coop/Anji/SixYear/Six.vue"),
                            children: [{
                                path: "maturity",
                                name: "six_year_maturity",
                                meta: {
                                    title: "六年平儲到期查詢",
                                    breadcrumb: "六年平儲到期查詢",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearReport.vue"),
                            },
                            {
                                path: "release",
                                name: "coop_six_year_release",
                                meta: {
                                    title: "六年平儲解約",
                                    breadcrumb: "六年平儲解約",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearRelease.vue"),
                            },
                            {
                                path: "roster",
                                name: "six_year_roster",
                                meta: {
                                    title: "六年平儲月名冊",
                                    breadcrumb: "六年平儲月名冊",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearReport.vue"),
                            },
                            {
                                path: "declare",
                                name: "six_year_declare",
                                meta: {
                                    title: "六年平儲申報表",
                                    breadcrumb: "六年平儲申報表",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearReport.vue"),
                            },
                            {
                                path: "check",
                                name: "six_year_check",
                                meta: {
                                    title: "六年平儲核對表",
                                    breadcrumb: "六年平儲核對表",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearReport.vue"),
                            },
                            {
                                path: "unpaid",
                                name: "six_year_unpaid",
                                meta: {
                                    title: "六年平儲未按期繳納名單",
                                    breadcrumb: "六年平儲未按期繳納名單",
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYearReport.vue"),
                            },
                            {
                                path: "",
                                name: "six_year",
                                meta: {
                                    title: "六年平儲申請件",
                                    breadcrumb: "六年平儲申請件",
                                    listKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Anji/SixYear/SixYear.vue"),
                                children: [{
                                    path: ":id",
                                    name: "six_year_edit",
                                    meta: {
                                        title: "六年平儲申請件",
                                        breadcrumb: "編輯",
                                    },
                                    component: () =>
                                        import("./views/coop/Anji/SixYear/SixYearEdit.vue"),
                                },],
                            },
                            ],
                        },
                    ],
                },
                // 放款作業
                {
                    path: "loan",
                    name: "loan",
                    meta: {
                        title: "放款作業",
                        breadcrumb: "放款作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Loan/Loan.vue"),
                    children: [
                        // 放款方案設定
                        {
                            path: "plan",
                            name: "loan_plan",
                            meta: {
                                title: "放款方案設定",
                                breadcrumb: "放款方案設定",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Loan/LoanPlan.vue"),
                            children: [{
                                path: ":code",
                                name: "loan_plan_edit",
                                meta: {
                                    title: "放款方案設定",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                beforeEnter: (to, from, next) => {
                                    if (to.params.id == "new") {
                                        // 新增不顯示其他 submenu
                                        to.meta.submenu = false;
                                    } else {
                                        to.meta.submenu = true;
                                    }
                                    next();
                                },
                                component: () =>
                                    import("./views/coop/Loan/LoanPlanEdit.vue"),
                                children: [{
                                    path: "account",
                                    name: "loan_plan_account",
                                    meta: {
                                        title: "放款會計科目設定",
                                        breadcrumb: "放款會計科目設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanAccount.vue"),
                                },
                                {
                                    path: "application",
                                    name: "loan_plan_application",
                                    meta: {
                                        title: "放款申請件",
                                        breadcrumb: "申請件",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanApplication.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "loan_plan_application_edit",
                                        meta: {
                                            title: "編輯",
                                            breadcrumb: "申請件",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/LoanPlanApplicationEdit.vue"),
                                    },],
                                },
                                {
                                    path: "document",
                                    name: "loan_plan_document",
                                    meta: {
                                        title: "繳交文件設定",
                                        breadcrumb: "繳交文件設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanDocument.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "loan_plan_document_edit",
                                        meta: {
                                            title: "編輯",
                                            breadcrumb: "繳交文件設定",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/LoanPlanDocumentEdit.vue"),
                                    },],
                                },
                                {
                                    path: "manage",
                                    name: "loan_plan_manage",
                                    meta: {
                                        title: "放款貸後管理",
                                        breadcrumb: "貸後管理",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanManage.vue"),
                                },
                                {
                                    path: "rate",
                                    name: "loan_plan_rate",
                                    meta: {
                                        title: "放款利率調整",
                                        breadcrumb: "利率調整",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanRate.vue"),
                                },
                                ],
                            },],
                        },
                        // 放款申請管理
                        {
                            path: "application",
                            name: "loan_application",
                            meta: {
                                title: "放款申請管理",
                                breadcrumb: "放款申請管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Loan/LoanApplication/LoanApplication.vue"),
                            children: [{
                                path: ":id",
                                name: "loan_application_edit",
                                meta: {
                                    title: "放款申請管理",
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Loan/LoanApplication/LoanApplicationEdit.vue"),
                                children: [{
                                    path: "guarantor",
                                    name: "loan_application_guarantor",
                                    meta: {
                                        title: "保證人",
                                        breadcrumb: "保證人",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanGuarantor.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "loan_application_guarantor_edit",
                                        meta: {
                                            title: "保證人",
                                            breadcrumb: "編輯",
                                            flowNotKeepAlive: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/LoanApplication/LoanGuarantorEdit.vue"),
                                    },],
                                },
                                {
                                    path: "doc",
                                    name: "loan_application_doc",
                                    meta: {
                                        title: "申請文件",
                                        breadcrumb: "申請文件",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanApplicationDoc.vue"),
                                },
                                {
                                    path: "financial",
                                    name: "loan_application_financial",
                                    meta: {
                                        title: "財務狀況",
                                        breadcrumb: "財務狀況",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanFinancial.vue"),
                                },
                                {
                                    path: "stock",
                                    name: "loan_application_stock",
                                    meta: {
                                        title: "股金借款記錄表",
                                        breadcrumb: "股金借款記錄表",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanStock.vue"),
                                },
                                {
                                    path: "review",
                                    name: "loan_application_review",
                                    meta: {
                                        title: "審查紀錄",
                                        breadcrumb: "審查紀錄",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanReview.vue"),
                                },
                                {
                                    path: "collateral",
                                    name: "loan_application_collateral",
                                    meta: {
                                        title: "擔保品鑑價與審查",
                                        breadcrumb: "擔保品鑑價與審查",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanCollateral.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "loan_application_collateral_edit",
                                        meta: {
                                            title: "擔保品管理",
                                            breadcrumb: "編輯",
                                            flowNotKeepAlive: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/LoanApplication/LoanCollateralEdit.vue"),
                                    },],
                                },
                                {
                                    path: "report_print",
                                    name: "loan_application_reportprint",
                                    meta: {
                                        title: "放款委員會報表列印",
                                        breadcrumb: "放款委員會報表列印",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanReportPrint.vue"),
                                },
                                {
                                    path: "committee_review",
                                    name: "loan_application_committeereview",
                                    meta: {
                                        title: "審查紀錄",
                                        breadcrumb: "審查紀錄",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanCommitteeReview.vue"),
                                },
                                {
                                    path: "borrowing",
                                    name: "loan_application_borrowing",
                                    meta: {
                                        title: "借據及對保資料",
                                        breadcrumb: "借據及對保資料",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanBorrowing.vue"),
                                },
                                {
                                    path: "ratification",
                                    name: "loan_application_ratification",
                                    meta: {
                                        title: "追認作業",
                                        breadcrumb: "追認作業",
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanApplication/LoanRatification.vue"),
                                },
                                ],
                            },],
                        },
                        // 貸後管理
                        {
                            path: "after_loan",
                            name: "after_loan",
                            meta: {
                                title: "借據管理",
                                breadcrumb: "借據管理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Loan/AfterLoan/AfterLoan.vue"),
                            children: [{
                                path: ":id",
                                name: "after_loan_edit",
                                meta: {
                                    title: "借據管理",
                                    submenu: true,
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Loan/AfterLoan/AfterEdit.vue"),
                                children: [{
                                    path: "trial_calc",
                                    name: "after_loan_trialcalc",
                                    meta: {
                                        title: "借據還款試算",
                                        breadcrumb: "借據還款試算",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterTrialCalc.vue"),
                                },
                                {
                                    path: "breach_calc",
                                    name: "after_loan_breachcalc",
                                    meta: {
                                        title: "借據違約試算",
                                        breadcrumb: "借據違約試算",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/BreachTrialCalc.vue"),
                                },
                                {
                                    path: "doc",
                                    name: "after_loan_doc",
                                    meta: {
                                        title: "相關文件管理",
                                        breadcrumb: "相關文件管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterDoc.vue"),
                                },
                                {
                                    path: "collateral",
                                    name: "after_loan_collateral",
                                    meta: {
                                        title: "擔保品管理",
                                        breadcrumb: "擔保品管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterLoanCollateral.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_collateral_edit",
                                        meta: {
                                            title: "擔保品管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterLoanCollateralEdit.vue"),
                                    },],
                                },
                                {
                                    path: "guarantor",
                                    name: "after_loan_guarantor",
                                    meta: {
                                        title: "保證人管理",
                                        breadcrumb: "保證人管理",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterLoanGuarantor.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_guarantor_edit",
                                        meta: {
                                            title: "保證人管理",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterLoanGuarantorEdit.vue"),
                                    },],
                                },
                                {
                                    path: "extension",
                                    name: "after_loan_extension",
                                    meta: {
                                        title: "延期協議設定",
                                        breadcrumb: "延期協議設定",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterExtension.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_extension_edit",
                                        meta: {
                                            title: "延期協議設定",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterExtensionEdit.vue"),
                                    },],
                                },
                                {
                                    path: "prepayment-setting",
                                    name: "after_loan_prepaymentsetting",
                                    meta: {
                                        title: "本息定額借款提前清償設定",
                                        breadcrumb: "本息定額借款提前清償設定",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterPrepaymentSetting.vue"),
                                },
                                {
                                    path: "prepayment",
                                    name: "after_loan_prepayment",
                                    meta: {
                                        title: "本息定額借款提前清償申請",
                                        breadcrumb: "本息定額借款提前清償申請",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterPrepayment.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_prepayment_edit",
                                        meta: {
                                            title: "本息定額借款提前清償申請",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterPrepaymentEdit.vue"),
                                    },],
                                },
                                {
                                    path: "overdue",
                                    name: "after_loan_overdue",
                                    meta: {
                                        title: "逾期約定償還",
                                        breadcrumb: "逾期約定償還",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterExtension.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_overdue_edit",
                                        meta: {
                                            title: "逾期約定償還",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterExtensionEdit.vue"),
                                    },],
                                },
                                {
                                    path: "record",
                                    name: "after_loan_record",
                                    meta: {
                                        title: "記錄",
                                        breadcrumb: "記錄",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterRecord.vue"),
                                },
                                {
                                    path: "telephone",
                                    name: "after_loan_telephone",
                                    meta: {
                                        title: "電話催收工作",
                                        breadcrumb: "電話催收工作",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterTelephone.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_telephone_edit",
                                        meta: {
                                            title: "電話催收工作",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterTelephoneEdit.vue"),
                                    },],
                                },
                                {
                                    path: "written",
                                    name: "after_loan_written",
                                    meta: {
                                        title: "書面催收工作",
                                        breadcrumb: "書面催收工作",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterWritten.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_written_edit",
                                        meta: {
                                            title: "書面催收工作",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterWrittenEdit.vue"),
                                    },],
                                },
                                {
                                    path: "legal",
                                    name: "after_loan_legal",
                                    meta: {
                                        title: "法律催收工作",
                                        breadcrumb: "法律催收工作",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterLegal.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "after_loan_legal_edit",
                                        meta: {
                                            title: "法律催收工作還",
                                            breadcrumb: "編輯",
                                            submenu: true,
                                        },
                                        component: () =>
                                            import("./views/coop/Loan/AfterLoan/AfterLegalEdit.vue"),
                                    },],
                                },
                                {
                                    path: "bad_loan",
                                    name: "after_loan_badloan",
                                    meta: {
                                        title: "呆帳轉銷作業",
                                        breadcrumb: "呆帳轉銷作業",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterBadLoan.vue"),
                                },
                                {
                                    path: "bad_loan_return",
                                    name: "after_loan_badloanreturn",
                                    meta: {
                                        title: "呆帳轉銷後收回作業",
                                        breadcrumb: "呆帳轉銷後收回作業",
                                        submenu: true,
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/AfterLoan/AfterBadLoanReturn.vue"),
                                },
                                ],
                            },],
                        },
                        //未取款借據
                        {
                            path: "unwithdrawn_debit",
                            name: "unwithdrawn_debit",
                            meta: {
                                title: "未取款借據",
                                breadcrumb: "未取款借據",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Loan/UnwithdrawnDebit.vue"),
                        },
                        // 還款試算表
                        {
                            path: "repayment_balance",
                            name: "repayment_balance",
                            meta: {
                                title: "還款試算表",
                                breadcrumb: "還款試算表",
                            },
                            component: () =>
                                import("./views/coop/Loan/RepaymentBalance.vue"),
                        },
                        // 放款應收利息試算表
                        {
                            path: "lending_interest_receivable",
                            name: "lending_interest_receivable",
                            meta: {
                                title: "放款應收利息試算表",
                                breadcrumb: "放款應收利息試算表",
                            },
                            component: () =>
                                import("./views/coop/Loan/LendingInterestReceivable.vue"),
                        },
                        //借款條件異動處理
                        {
                            path: "loan_plan_change",
                            name: "loan_plan_change",
                            meta: {
                                title: "借款條件異動處理",
                                breadcrumb: "借款條件異動處理",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Loan/LoanPlanChange.vue"),
                            children: [{
                                path: ":id",
                                name: "loan_plan_change_edit",
                                meta: {
                                    title: "理事會同意紀錄",
                                    breadcrumb: "理事會同意紀錄",
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Loan/LoanPlanChangeEdit.vue"),
                                children: [{
                                    path: "project",
                                    name: "loan_plan_change_project",
                                    meta: {
                                        title: "設定新方案與減免",
                                        breadcrumb: "設定新方案與減免",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeProject.vue"),
                                },
                                {
                                    path: "director_review",
                                    name: "loan_plan_change_review_director",
                                    meta: {
                                        title: "主任審查",
                                        breadcrumb: "主任審查",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeReview.vue"),
                                },
                                {
                                    path: "manager_review",
                                    name: "loan_plan_change_review_manager",
                                    meta: {
                                        title: "經理審查",
                                        breadcrumb: "經理審查",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeReview.vue"),
                                },
                                {
                                    path: "council_review",
                                    name: "loan_plan_change_review_council",
                                    meta: {
                                        title: "理事會審查",
                                        breadcrumb: "理事會審查",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeReview.vue"),
                                },
                                {
                                    path: "supervision_review",
                                    name: "loan_plan_change_review_supervision",
                                    meta: {
                                        title: "督導審查",
                                        breadcrumb: "督導審查",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeReview.vue"),
                                },
                                {
                                    path: "supervision_manager_review",
                                    name: "loan_plan_change_project_supervision_manager",
                                    meta: {
                                        title: "督導組長審查",
                                        breadcrumb: "督導組長審查",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeReview.vue"),
                                },
                                {
                                    path: "coop_recheck",
                                    name: "loan_plan_change_coop_recheck",
                                    meta: {
                                        title: "儲互社確認",
                                        breadcrumb: "儲互社確認",
                                        subKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Loan/LoanPlanChangeCoopRecheck.vue"),
                                },
                                ],
                            },],
                        },
                    ],
                },
                // 審核作業
                {
                    path: "coop_review",
                    name: "coop_review",
                    meta: {
                        title: "審核作業",
                        breadcrumb: "審核作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Review/Review.vue"),
                    children: [{
                        path: "coop_review_voucher_list",
                        name: "coop_review_voucher_list",
                        meta: {
                            title: "傳票審核",
                            breadcrumb: "傳票審核",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Review/ReviewVoucherList.vue"),
                        children: [{
                            path: ":id",
                            name: "coop_review_voucher_edit",
                            meta: {
                                title: "傳票審核",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Review/ReviewListEdit.vue"),
                        },],
                    },
                    {
                        path: "coop_review_other_list",
                        name: "coop_review_other_list",
                        meta: {
                            title: "其他審核",
                            breadcrumb: "其他審核",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Review/ReviewList.vue"),
                        children: [{
                            path: ":id",
                            name: "coop_review_other_edit",
                            meta: {
                                title: "其他審核",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Review/ReviewListEdit.vue"),
                        },],
                    },
                    {
                        path: "coop_review_history_list",
                        name: "coop_review_history_list",
                        meta: {
                            title: "歷史審查列表",
                            breadcrumb: "歷史審查列表",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Review/ReviewList.vue"),
                        children: [{
                            path: ":id",
                            name: "coop_review_history_edit",
                            meta: {
                                title: "歷史審查列表",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Review/ReviewListEdit.vue"),
                        },],
                    },],
                },
                // 會計作業 Account
                {
                    path: "coop_account",
                    name: "coop_account",
                    meta: {
                        title: "會計作業首頁",
                        breadcrumb: "會計作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Account/Account.vue"),
                    children: [{
                        path: "magzin",
                        name: "magzin",
                        meta: {
                            title: "雜誌訂閱資料",
                            breadcrumb: "雜誌訂閱資料",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/Magzin.vue"),
                    },

                    {
                        path: "subpoena_confirm",
                        name: "subpoena_confirm",
                        meta: {
                            title: "傳票確認作業",
                            breadcrumb: "傳票確認作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/SubpoenaConfirm.vue"),
                    },
                    {
                        path: "subpoenaReport/:id",
                        name: "subpoena_report",
                        meta: {
                            title: "傳票確認作業",
                            breadcrumb: "傳票確認作業",
                        },
                        component: () =>
                            import("./views/coop/Account/SubpoenaConfirmReport.vue"),
                    },
                    //  傳票管理
                    {
                        path: "summons",
                        name: "coop_summons",
                        meta: {
                            title: "傳票管理",
                            breadcrumb: "傳票管理",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/Summons.vue"),
                        children: [
                            // {
                            //     path: 'edit',
                            //     name: 'coop_summons_edit',
                            //     meta: { title: '傳票管理', breadcrumb: '編輯', formKeepAlive: true },
                            //     component: () =>
                            //         import ('./views/coop/Account/Summons/SummonsEdit.vue'),
                            // },
                            // {
                            //     path: 'report',
                            //     name: 'coop_summons_report',
                            //     meta: {},
                            //     component: () =>
                            //         import ('./views/coop/Account/Summons/SummonsReport.vue'),
                            // },
                        ],
                    },
                    {
                        path: "summons/edit",
                        name: "coop_summons_edit",
                        meta: {
                            title: "傳票管理",
                            breadcrumb: "編輯",
                            formKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/SummonsEdit.vue"),
                        children: [{
                            path: "report",
                            name: "coop_summons_report",
                            meta: {},
                            component: () =>
                                import("./views/coop/Account/Summons/SummonsReport.vue"),
                        },],
                    },
                    {
                        path: "review_summons",
                        name: "review_summons",
                        meta: {
                            title: "審查中傳票管理",
                            breadcrumb: "審查中傳票管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/ReviewSummons.vue"),
                        children: [{
                            path: ":id",
                            name: "review_summons_edit",
                            meta: {
                                title: "審查中傳票管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Account/Summons/ReviewSummonsEdit.vue"),
                        },],
                    },
                    {
                        path: "ec_summons",
                        name: "ec_coop_summons",
                        meta: {
                            title: "EC傳票管理",
                            breadcrumb: "EC傳票管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/ECSummons.vue"),
                    },
                    {
                        path: "total_summons",
                        name: "total_summons",
                        meta: {
                            title: "各科目總和傳票",
                            breadcrumb: "各科目總和傳票",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/TotalSummons.vue"),
                    },
                    {
                        path: "transfer_total_summons",
                        name: "transfer_total_summons",
                        meta: {
                            title: "委託轉帳總和傳票",
                            breadcrumb: "委託轉帳總和傳票",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/TansferTotalSummons.vue"),
                    },
                    {
                        path: "receipt",
                        name: "coop_receipt",
                        meta: {
                            title: "收款單管理",
                            breadcrumb: "收款單管理",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/Receipt.vue"),
                    },
                    {
                        path: "expense_summons",
                        name: "expense_summons",
                        meta: {
                            title: "支出轉帳傳票管理",
                            breadcrumb: "支出轉帳傳票管理",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/ExpenseSummons.vue"),
                    },
                    {
                        path: "cash_receipt_sum",
                        name: "cash_receipt_sum",
                        meta: {
                            title: "現金收入總和傳票",
                            breadcrumb: "現金收入總和傳票",
                        },
                        component: () =>
                            import("./views/coop/Account/Summons/CashReceiptSum.vue"),
                    },
                    // 傳票管理 END
                    {
                        path: "income_daily",
                        name: "income_daily",
                        meta: {
                            title: "收款日計表",
                            breadcrumb: "收款日計表",
                        },
                        component: () =>
                            import("./views/coop/Account/IncomeDaily.vue"),
                    },
                    {
                        path: "income_expenditure_daily",
                        name: "income_expenditure_daily",
                        meta: {
                            title: "收支日計表",
                            breadcrumb: "收支日計表",
                        },
                        component: () =>
                            import("./views/coop/Account/IncomeExpenditureDaily.vue"),
                    },
                    {
                        path: "account_subject",
                        name: "account_subject",
                        meta: {
                            title: "會計科目分類帳",
                            breadcrumb: "會計科目分類帳",
                        },
                        component: () =>
                            import("./views/coop/Account/AccountSubject.vue"),
                    },
                    {
                        path: "member_salary",
                        name: "member_salary",
                        meta: {
                            title: "社員薪資轉帳作業",
                            breadcrumb: "社員薪資轉帳作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/MemberSalary.vue"),
                        children: [{
                            path: ":id",
                            name: "member_salary_edit",
                            meta: {
                                title: "社員薪資轉帳作業",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Account/MemberSalaryEdit.vue"),
                        },],
                    },
                    {
                        path: "transfer_detail",
                        name: "transfer_detail",
                        meta: {
                            title: "薪資轉帳個人扣款明細單",
                            breadcrumb: "薪資轉帳個人扣款明細單",
                        },
                        component: () =>
                            import("./views/coop/Account/TransferDetail.vue"),
                    },
                    {
                        path: "staff_salary",
                        name: "staff_salary",
                        meta: {
                            title: "職員薪資計算作業",
                            breadcrumb: "職員薪資計算作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/StaffSalary.vue"),
                        children: [{
                            path: ":id",
                            name: "staff_salary_edit",
                            meta: {
                                title: "職員薪資計算作業",
                                breadcrumb: "編輯",
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Account/StaffSalaryEdit.vue"),
                            children: [{
                                path: "printReport",
                                name: "staff_salary_print",
                                meta: {
                                    title: "職員薪資計算作業",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/coop/Account/StaffSalaryPrintReport.vue"),
                            },],
                        },],
                    },
                    {
                        path: "staff_salary_project",
                        name: "staff_salary_project",
                        meta: {
                            title: "職員薪資項目設定範本",
                            breadcrumb: "職員薪資項目設定範本",
                        },
                        component: () =>
                            import("./views/coop/Account/StaffSalaryProject.vue"),
                    },
                    {
                        path: "entrusted_transfer",
                        name: "entrusted_transfer",
                        meta: {
                            title: "委託轉帳作業",
                            breadcrumb: "委託轉帳作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/EntrustedTransfer.vue"),
                        children: [{
                            path: ":id",
                            name: "entrusted_transfer_edit",
                            meta: {
                                title: "委託轉帳作業",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Account/EntrustedTransferEdit.vue"),
                            children: [{
                                path: "summons",
                                name: "entrusted_transfer_summons",
                                meta: {
                                    title: "傳票紀錄",
                                    breadcrumb: "傳票紀錄",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Account/EntrustedTransferSummons.vue"),
                            },],
                        },],
                    },
                    {
                        path: "entrusted_transfer_result",
                        name: "entrusted_transfer_result",
                        meta: {
                            title: "委託轉帳處理結果",
                            breadcrumb: "委託轉帳處理結果",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/EntrustedTransferResult.vue"),
                    },
                    // 特定轉帳作業
                    {
                        path: "specific_transfer",
                        name: "specific_transfer",
                        meta: {
                            title: "特定轉帳作業",
                            breadcrumb: "特定轉帳作業",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/SpecificTransfer/SpecificTransfer.vue"),
                        children: [{
                            path: ":id",
                            name: "specific_transfer_edit",
                            meta: {
                                title: "特定轉帳作業",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Account/SpecificTransfer/SpecificTransferEdit.vue"),
                            children: [{
                                path: "detial",
                                name: "specific_transfer_detial",
                                meta: {
                                    title: "特定轉帳明細",
                                    breadcrumb: "特定轉帳明細",
                                    submenu: true,
                                    subListKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Account/SpecificTransfer/SpecificTransferDetail.vue"),
                                children: [{
                                    path: ":subId",
                                    name: "specific_transfer_detial_edit",
                                    meta: {
                                        title: "特定轉帳明細",
                                        breadcrumb: "特定轉帳明細",
                                        submenu: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/SpecificTransfer/SpecificTransferDetailEdit.vue"),
                                },],
                            },
                            {
                                path: "log",
                                name: "specific_transfer_log",
                                meta: {
                                    title: "傳票紀錄",
                                    breadcrumb: "傳票紀錄",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Account/SpecificTransfer/SpecificTransferLog.vue"),
                            },
                            ],
                        },],
                    },
                    {
                        path: "processing",
                        name: "specific_transfer_processing",
                        meta: {
                            title: "特定轉帳作業處理",
                            breadcrumb: "特定轉帳作業處理",
                            formKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/SpecificTransfer/SpecificTransferProcessing.vue"),
                        children: [{
                            path: ":id",
                            name: "specific_transfer_processing_edit",
                            meta: {
                                title: "編輯",
                                breadcrumb: "特定轉帳作業處理",
                            },
                            component: () =>
                                import("./views/coop/Account/SpecificTransfer/SpecificTransferProcessingEdit.vue"),
                        },],
                    },
                    // 年度預算管理
                    {
                        path: "annual_budget",
                        name: "annual_budget",
                        meta: {
                            title: "年度預算管理",
                            breadcrumb: "年度預算管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/AnnualBudget.vue"),
                        children: [{
                            path: ":id",
                            name: "annual_budget_edit",
                            meta: {
                                title: "年度預算管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Account/AnnualBudgetEdit.vue"),
                        },],
                    },
                    // 股息扣繳媒體申報資料轉出
                    {
                        path: "dividends_media",
                        name: "dividends_media",
                        meta: {
                            title: "股息扣繳媒體申報資料轉出",
                            breadcrumb: "股息扣繳媒體申報資料轉出",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Account/DividendsMedia"),
                    },
                    // 自動傳票清單明細
                    {
                        path: "automatic_voucher",
                        name: "automatic_voucher",
                        meta: {
                            title: "自動傳票清單明細",
                            breadcrumb: "自動傳票清單明細",
                        },
                        component: () =>
                            import("./views/coop/Account/AutomaticVoucher.vue"),
                    },
                    // 安基傳票分錄明細
                    {
                        path: "ins_plan_entry",
                        name: "ins_plan_entry",
                        meta: {
                            title: "安基傳票分錄明細",
                            breadcrumb: "安基傳票分錄明細",
                        },
                        component: () =>
                            import("./views/coop/Account/InsPlanEntry.vue"),
                    },
                    // 日結作業
                    {
                        path: "daliy",
                        meta: {
                            title: "日結作業",
                            breadcrumb: "日結作業",
                        },
                        component: () =>
                            import("./views/coop/Account/Daily/Daily.vue"),
                        children: [{
                            path: "journal",
                            name: "journal",
                            meta: {
                                title: "日記帳",
                                breadcrumb: "日記帳",
                            },
                            component: () =>
                                import("./views/coop/Account/Daily/Journal.vue"),
                        },
                        {
                            path: "report",
                            name: "daily_report",
                            meta: {
                                title: "日報表",
                                breadcrumb: "日報表",
                            },
                            component: () =>
                                import("./views/coop/Account/Daily/DailyReport.vue"),
                        },
                        {
                            path: "cash_bank",
                            name: "cash_bank_daily_report",
                            meta: {
                                title: "現金/銀行存款日報表",
                                breadcrumb: "現金/銀行存款日報表",
                            },
                            component: () =>
                                import("./views/coop/Account/Daily/CashBankDailyReport.vue"),
                        },
                        ],
                    },
                    // 月結作業
                    {
                        path: "monthly",
                        meta: {
                            title: " 月結作業",
                            breadcrumb: " 月結作業",
                        },
                        component: () =>
                            import("./views/coop/Account/Monthly/Monthly.vue"),
                        children: [{
                            path: "stock_lending",
                            name: "stock_lending",
                            meta: {
                                title: "股金放款核對表",
                                breadcrumb: "股金放款核對表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/StockLending.vue"),
                        },
                        {
                            path: "reserve_transfer",
                            name: "reserve_transfer",
                            meta: {
                                title: "備轉金核對表",
                                breadcrumb: "備轉金核對表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/ReserveTransfer.vue"),
                        },
                        {
                            path: "quasi_member_checklist",
                            name: "quasi_member_checklist",
                            meta: {
                                title: "準社員核對表",
                                breadcrumb: "準社員核對表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/QuasiMemberChecklist.vue"),
                        },
                        {
                            path: "financial_business",
                            name: "financial_business",
                            meta: {
                                title: "財務業務統計表",
                                breadcrumb: "財務業務統計表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/FinancialBusiness.vue"),
                        },
                        {
                            path: "balance_sheet",
                            name: "balance_sheet",
                            meta: {
                                title: "資產負債表",
                                breadcrumb: "資產負債表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/BalanceSheet.vue"),
                        },
                        {
                            path: "profit_loss",
                            name: "profit_loss",
                            meta: {
                                title: "損益表",
                                breadcrumb: "損益表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/ProfitLoss.vue"),
                        },
                        {
                            path: "profit_loss_pre",
                            name: "profit_loss_pre",
                            meta: {
                                title: "損益表(預決算比較)",
                                breadcrumb: "損益表(預決算比較)",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/ProfitLossPre.vue"),
                        },
                        {
                            path: "loan_asset",
                            name: "loan_asset",
                            meta: {
                                title: "放款資產評估明細表",
                                breadcrumb: "放款資產評估明細表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/LoanAsset.vue"),
                        },
                        {
                            path: "loan_asset_classification",
                            name: "loan_asset_classification",
                            meta: {
                                title: "放款資產評估分類明細表",
                                breadcrumb: "放款資產評估分類明細表",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/LoanAssetClassification.vue"),
                        },
                        {
                            path: "manual_monthly",
                            name: "manual_monthly",
                            meta: {
                                title: "手動月結作業",
                                breadcrumb: "手動月結作業",
                            },
                            component: () =>
                                import("./views/coop/Account/Monthly/ManualMonthly.vue"),
                        },
                        ],
                    },
                    // 年結作業
                    {
                        path: "year",
                        meta: {
                            title: "年結作業",
                            breadcrumb: "年結作業",
                        },
                        component: () =>
                            import("./views/coop/Account/Year/Year.vue"),
                        children: [{
                            path: "detailed_ledger",
                            name: "detailed_ledger",
                            meta: {
                                title: "明細分類帳",
                                breadcrumb: "明細分類帳",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/DetailedLedger.vue"),
                        },
                        {
                            path: "general_ledger",
                            name: "general_ledger",
                            meta: {
                                title: "總分類帳",
                                breadcrumb: "總分類帳",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/GeneralLedger.vue"),
                        },
                        {
                            path: "round_number",
                            name: "round_number",
                            meta: {
                                title: "圓股數明細表",
                                breadcrumb: "圓股數明細表",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/RoundNumber.vue"),
                        },
                        {
                            path: "loan_use",
                            name: "loan_use",
                            meta: {
                                title: "放款用途統計",
                                breadcrumb: "放款用途統計",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/LoanUse.vue"),
                        },
                        {
                            path: "dividends",
                            name: "dividends",
                            meta: {
                                title: "股利攤還表",
                                breadcrumb: "股利攤還表",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/Dividends.vue"),
                        },
                        {
                            path: "transfer_dividends",
                            name: "transfer_dividends",
                            meta: {
                                title: "備轉金股息明細表",
                                breadcrumb: "備轉金股息明細表",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/TransferDividends.vue"),
                        },
                        {
                            path: "bank_statement_member",
                            name: "bank_statement_member",
                            meta: {
                                title: "社員對帳單",
                                breadcrumb: "社員對帳單",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/BankStatementMember.vue"),
                        },
                        {
                            path: "bank_statement_association",
                            name: "bank_statement_association",
                            meta: {
                                title: "社員對帳單",
                                breadcrumb: "社員對帳單",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/BankStatementAssociation.vue"),
                        },
                        {
                            path: "bank_statement_return",
                            name: "bank_statement_return",
                            meta: {
                                title: "社員對帳單",
                                breadcrumb: "社員對帳單",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/BankStatementMemberReturn.vue"),
                        },
                        {
                            path: "advertising_cover",
                            name: "advertising_cover",
                            meta: {
                                title: "廣告回函封面",
                                breadcrumb: "廣告回函封面",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/AdvertisingCover.vue"),
                        },
                        {
                            path: "advertising_reply",
                            name: "advertising_reply",
                            meta: {
                                title: "對帳單(廣告回函用)",
                                breadcrumb: "對帳單(廣告回函用)",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/AdvertisingReply.vue"),
                        },
                        {
                            path: "annotation_remarks",
                            name: "annotation_remarks",
                            meta: {
                                title: "對帳單備註欄註記管理",
                                breadcrumb: "對帳單備註欄註記管理",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/AnnotationRemarks.vue"),
                        },
                        {
                            path: "member_annual",
                            name: "member_annual",
                            meta: {
                                title: "社員年度個人帳",
                                breadcrumb: "社員年度個人帳",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/MemberAnnual.vue"),
                        },
                        {
                            path: "transfer_annual",
                            name: "transfer_annual",
                            meta: {
                                title: "備轉金年度個人帳",
                                breadcrumb: "備轉金年度個人帳",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/TransferAnnual.vue"),
                        },
                        {
                            path: "annual_fee",
                            name: "annual_fee",
                            meta: {
                                title: "社員年費各類明細表",
                                breadcrumb: "社員年費各類明細表",
                            },
                            component: () =>
                                import("./views/coop/Account/Year/AnnualFee.vue"),
                        },
                        // 年結
                        {
                            path: "annual_knot",
                            name: "annual_knot",
                            meta: {
                                title: "歷年年結紀錄",
                                breadcrumb: "歷年年結紀錄",
                                listKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Account/Year/AnnualKnot.vue"),
                            children: [{
                                path: ":id",
                                name: "annual_knot_edit",
                                meta: {
                                    title: "歷年年結紀錄",
                                    formKeepAlive: true,
                                },
                                component: () =>
                                    import("./views/coop/Account/Year/AnnualKnotEdit.vue"),
                                children: [{
                                    path: "setting",
                                    name: "annual_knot_setting",
                                    meta: {
                                        title: "發放項目設定",
                                        breadcrumb: "發放項目設定",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotSetting.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "annual_knot_setting_edit",
                                        meta: {
                                            title: "發放項目設定",
                                            breadcrumb: "編輯",
                                        },
                                        component: () =>
                                            import("./views/coop/Account/Year/AnnualKnotSettingEdit.vue"),
                                    },],
                                },
                                {
                                    path: "deduction",
                                    name: "annual_knot_deduction",
                                    meta: {
                                        title: "代扣款項目設定",
                                        breadcrumb: "代扣款項目設定",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotDeduction.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "annual_knot_deduction_edit",
                                        meta: {
                                            title: "代扣款項目設定",
                                            breadcrumb: "編輯",
                                        },
                                        component: () =>
                                            import("./views/coop/Account/Year/AnnualKnotDeductionEdit.vue"),
                                    },],
                                },
                                {
                                    path: "dividend",
                                    name: "annual_knot_dividendpayment",
                                    meta: {
                                        title: "股息發放方式設定",
                                        breadcrumb: "股息發放方式設定",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotDividendPayment.vue"),
                                },
                                {
                                    path: "withholding",
                                    name: "annual_knot_withholding",
                                    meta: {
                                        title: "股息發放代扣設定",
                                        breadcrumb: "股息發放代扣設定",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotWithholding.vue"),
                                    children: [{
                                        path: ":subId",
                                        name: "annual_knot_withholding_edit",
                                        meta: {
                                            title: "股息發放代扣設定",
                                            breadcrumb: "編輯",
                                        },
                                        component: () =>
                                            import("./views/coop/Account/Year/AnnualKnotWithholdingEdit.vue"),
                                    },],
                                },
                                {
                                    path: "ordinary",
                                    name: "annual_knot_ordinary",
                                    meta: {
                                        title: "普通股利發放",
                                        breadcrumb: "普通股利發放",
                                        subListKeepAlive: true,
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotOrdinary.vue"),
                                },
                                {
                                    path: "list",
                                    name: "annual_knot_list",
                                    meta: {
                                        title: "各式表單",
                                        breadcrumb: "各式表單",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotList.vue"),
                                },
                                {
                                    path: "receipt",
                                    name: "annual_knot_receipt",
                                    meta: {
                                        title: "股息發放簽收明細表",
                                        breadcrumb: "股息發放簽收明細表",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotReceipt.vue"),
                                },
                                {
                                    path: "director_review",
                                    name: "annual_knot_director_review",
                                    meta: {
                                        title: "審查作業",
                                        breadcrumb: "審查作業",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotDirectorReview.vue"),
                                },
                                {
                                    path: "manager_review",
                                    name: "annual_knot_manager_review",
                                    meta: {
                                        title: "經理審查",
                                        breadcrumb: "經理審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotManagerReview.vue"),
                                },
                                {
                                    path: "supervise_review",
                                    name: "annual_knot_supervise_review",
                                    meta: {
                                        title: "督導審查",
                                        breadcrumb: "督導審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotSuperviseReview.vue"),
                                },
                                {
                                    path: "supervise_leader_review",
                                    name: "annual_knot_supervise_leader_review",
                                    meta: {
                                        title: "督導組長審查",
                                        breadcrumb: "督導組長審查",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotSuperviseReviewLeader.vue"),
                                },
                                {
                                    path: "trial",
                                    name: "annual_knot_trial",
                                    meta: {
                                        title: "年結試算",
                                        breadcrumb: "年結試算",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotTrial.vue"),
                                },
                                {
                                    path: "end",
                                    name: "annual_knot_end",
                                    meta: {
                                        title: "年終結算報告書",
                                        breadcrumb: "年終結算報告書",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotEnd.vue"),
                                },
                                {
                                    path: "assembly",
                                    name: "annual_knot_assembly",
                                    meta: {
                                        title: "社員大會確認",
                                        breadcrumb: "社員大會確認",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotAssembly.vue"),
                                },
                                {
                                    path: "notice_print",
                                    name: "annual_knot_noticeprint",
                                    meta: {
                                        title: "通知單列印",
                                        breadcrumb: "通知單列印",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotNoticePrint.vue"),
                                },
                                {
                                    path: "dividends",
                                    name: "annual_knot_dividends",
                                    meta: {
                                        title: "股利發放扣款不足明細表",
                                        breadcrumb: "股利發放扣款不足明細表",
                                    },
                                    component: () =>
                                        import("./views/coop/Account/Year/AnnualKnotDividends.vue"),
                                },
                                ],
                            },],
                        },
                        ],
                    },
                    ],
                },
                // 出納作業
                {
                    path: "cashier",
                    name: "cashier",
                    meta: {
                        title: "出納作業",
                        breadcrumb: "出納作業",
                        homeKeepAlive: true,
                    },
                    component: () =>
                        import("./views/coop/Cashier/Cashier.vue"),
                    children: [{
                        path: "bank_transaction",
                        name: "bank_transaction",
                        meta: {
                            title: "銀行交易明細管理",
                            breadcrumb: "銀行交易明細管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cashier/BankTransaction.vue"),
                        children: [{
                            path: ":id",
                            name: "bank_transaction_edit",
                            meta: {
                                title: "銀行交易明細管理",
                                breadcrumb: "編輯",
                            },
                            component: () =>
                                import("./views/coop/Cashier/BankTransactionEdit.vue"),
                        },],
                    },
                    {
                        path: "property",
                        name: "property",
                        meta: {
                            title: "財產清冊管理",
                            breadcrumb: "財產清冊管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cashier/Property.vue"),
                        children: [{
                            path: ":id",
                            name: "property_edit",
                            meta: {
                                title: "財產清冊管理",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cashier/PropertyEdit.vue"),
                            children: [{
                                path: "summons",
                                name: "property_summons",
                                meta: {
                                    title: "相關傳票",
                                    breadcrumb: "相關傳票",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Cashier/PropertySummons.vue"),
                            },],
                        },],
                    },
                    {
                        path: "retire_property",
                        name: "retire_property",
                        meta: {
                            title: "財產報廢管理",
                            breadcrumb: "財產報廢管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Cashier/RetireProperty.vue"),
                        children: [{
                            path: ":id",
                            name: "retire_property_edit",
                            meta: {
                                title: "財產報廢管理",
                                submenu: true,
                                formKeepAlive: true,
                            },
                            component: () =>
                                import("./views/coop/Cashier/RetirePropertyEdit.vue"),
                            children: [{
                                path: "summons",
                                name: "retire_property_summons",
                                meta: {
                                    title: "相關傳票",
                                    breadcrumb: "相關傳票",
                                    submenu: true,
                                },
                                component: () =>
                                    import("./views/coop/Cashier/PropertySummons.vue"),
                            },],
                        },],
                    },
                    ],
                },
                // 日結作業
                {
                    path: "daily",
                    name: "daily",
                    meta: {
                        title: "日結作業",
                        breadcrumb: "日結作業",
                    },
                    component: () =>
                        import("./views/coop/Daily/Daily.vue"),
                    children: [
                        // 日結作業_主管
                        {
                            path: "daily_supervisor",
                            name: "daily_supervisor",
                            meta: {
                                title: "日結作業",
                                breadcrumb: "主管",
                            },
                            component: () =>
                                import("./views/coop/Daily/DailySupervisor.vue"),
                        },
                        // 日結作業_臨櫃
                        {
                            path: "daily_cabinet",
                            name: "daily_cabinet",
                            meta: {
                                title: "日結作業",
                                breadcrumb: "臨櫃",
                            },
                            component: () =>
                                import("./views/coop/Daily/DailyCabinet.vue"),
                        },
                        // 日結作業_出納
                        {
                            path: "daily_cashier",
                            name: "daily_cashier",
                            meta: {
                                title: "日結作業",
                                breadcrumb: "出納",
                            },
                            component: () =>
                                import("./views/coop/Daily/DailyCashier.vue"),
                        },
                        // 日結作業_會計
                        {
                            path: "daily_account",
                            name: "daily_account",
                            meta: {
                                title: "日結作業",
                                breadcrumb: "會計",
                            },
                            component: () =>
                                import("./views/coop/Daily/DailyAccount.vue"),
                        },
                    ],
                },
                // 請款作業
                {
                    path: "request",
                    name: "request",
                    redirect: "request/all_payment",
                    meta: {
                        title: "請款作業",
                        breadcrumb: "請款作業",
                    },
                    component: () =>
                        import("./views/coop/Request/Request.vue"),
                    children: [{
                        path: "cabinet",
                        name: "request_cabinet",
                        meta: {
                            title: "請款單管理",
                            breadcrumb: "請款單管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/RequestCabinet.vue"),
                    },
                    {
                        path: "unopened_account",
                        name: "unopened_account",
                        meta: {
                            title: "未開立傳票請款單管理",
                            breadcrumb: "未開立傳票",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/UnopenedAccount.vue"),
                    },
                    {
                        path: "opened_account",
                        name: "opened_account",
                        meta: {
                            title: "已開立傳票請款單管理",
                            breadcrumb: "已開立傳票",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/OpenedAccount.vue"),
                    },
                    {
                        path: "not_uploaded",
                        name: "not_uploaded",
                        meta: {
                            title: "未上傳水單請款單管理",
                            breadcrumb: "未上傳水單",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/NotuploadCashier.vue"),
                    },
                    {
                        path: "uploaded_cashier",
                        name: "uploaded_cashier",
                        meta: {
                            title: "已上傳水單請款單管理",
                            breadcrumb: "已上傳水單",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/UploadCashier.vue"),
                    },
                    {
                        path: "all_payment",
                        name: "all_payment",
                        meta: {
                            title: "請款單管理",
                            breadcrumb: "請款單管理",
                            listKeepAlive: true,
                        },
                        component: () =>
                            import("./views/coop/Request/AllPaymentCashier.vue"),
                        children: [{
                            path: ":id",
                            meta: {
                                title: "請款單管理",
                            },
                            component: () =>
                                import("./views/coop/Request/AllPaymentEdit.vue"),
                            children: [{
                                path: "summons",
                                name: "all_payment_summons",
                                meta: {
                                    title: "手動開立傳票",
                                    breadcrumb: "手動開立傳票",
                                },
                                component: () =>
                                    import("./views/coop/Request/SummonsEdit.vue"),
                            },
                            {
                                path: "report",
                                name: "all_payment_summons_report",
                                meta: {
                                    title: "手動開立傳票",
                                    breadcrumb: "手動開立傳票",
                                },
                                component: () =>
                                    import("./views/coop/Request/SummonsEditReport.vue"),
                            },
                            {
                                path: "",
                                name: "all_payment_edit",
                                meta: {
                                    title: "請款單管理",
                                    breadcrumb: "編輯",
                                },
                                component: () =>
                                    import("./views/coop/Request/UnopenedAccountEdit.vue"),
                                children: [{
                                    path: "voucher_info",
                                    name: "all_payment_voucher_info",
                                    meta: {
                                        title: "請款單基本資料",
                                        breadcrumb: "請款單基本資料",
                                    },
                                    component: () =>
                                        import("./views/coop/Request/BaseInfo.vue"),
                                },
                                {
                                    path: "voucher_review",
                                    name: "all_payment_voucher_review",
                                    meta: {
                                        title: "列印紙本及輸入審查結果",
                                        breadcrumb: "列印紙本及輸入審查結果",
                                    },
                                    component: () =>
                                        import("./views/coop/Request/VoucherReview.vue"),
                                },
                                {
                                    path: "voucher",
                                    name: "all_payment_voucher",
                                    meta: {
                                        title: "會計開立發票",
                                        breadcrumb: "會計開立發票",
                                    },
                                    component: () =>
                                        import("./views/coop/Request/Voucher.vue"),
                                },
                                {
                                    path: "acoountiong_voucher",
                                    name: "all_payment_acoountiong_voucher",
                                    meta: {
                                        title: "出納繳款及上傳憑證",
                                        breadcrumb: "出納繳款及上傳憑證",
                                    },
                                    component: () =>
                                        import("./views/coop/Request/AccountingVoucher.vue"),
                                },
                                {
                                    path: "accounting_recognition",
                                    name: "all_payment_accounting_recognition",
                                    meta: {
                                        title: "會計確認",
                                        breadcrumb: "會計確認",
                                    },
                                    component: () =>
                                        import("./views/coop/Request/AccountingRecognition.vue"),
                                },
                                ],
                            },
                            ],
                        },],
                    },
                    ],
                },
            ],
        },
        ],
    },
    ],
});

Vue.use(Router);